import {
    getChampionshipDisplayName,
    getChampionshipPrestigeHtml, getChampionshipsDisplayName,
    getFeudHypeIncreasedHtml,
    getFeudPotentialHtml, getFeudStartedHtml,
    getGimmickDebutHtml,
    getGimmickEffectivenessLevelChangeHtml, getStarRatingHtml, getTournamentGroupName, makeGameRequest,
    showFactionReputationData, updateGamePointsAndFans
} from "./ui-helpers.js";
import {
    commaSeparate, gameLimits,
    getCurrentGame,
    getMonthsWord,
    getRandomChoice,
    shuffle,
    toTitleCase
} from "../modules/helpers.js";
import {getEventHypeHtml, showPlayMatchOrSegmentPage} from "./events.js";
import {showSuperstarInformation, showTagteamInformation} from "./booking.js";
import {
    animateGimmickEffectiveness,
    getEventResultParticipantManagersHtml,
    getMatchOrSegmentParticipantName,
    showUpdatesContainers
} from "./segments.js";
import {globals, globalUser} from "../modules/globals.js";
import {getTournamentBracketHtml, getTournamentGroupTableHtml} from "./manage-sub-menu.js";
import {showPlayMatchPageGraphic, turnMatchOrSegmentLoserGraphicOpaque} from "./graphics.js";
import {playSoundEffect} from "./sounds.js";
import {
    getAvailableMatchFinishes, getRandomGimmickMatch,
    getRandomOpponent,
    getRosterMembersForInterference,
    playMatch, simulateMatchWinnerRequest
} from "../modules/matches.js";
import {
    addCashinFutureMatch,
    addCashinToMatch,
    getChampionshipContractHolders,
    getChampionshipsForCashin
} from "../modules/championships.js";
import {loadHomePage} from "./home-page.js";
import {changeUserMatchResultSetting} from "../modules/games.js";
import {showNPCDialog} from "./dialog.js";
import {checkTutorialStepAction} from "./tutorial.js";

let playMatchHintShown = false;

$(document).ready(function() {
    // Show championship prestige details
    $('#prestige-results').off('click', '.show-championship-prestige-details');
    $('#prestige-results').on('click', '.show-championship-prestige-details', function () {
        $(this).parent().siblings('.championship-prestige-details').toggleClass('display-none')
    });

    // Show faction reputation details
    $('#prestige-results').off('click', '.show-faction-reputation-details');
    $('#prestige-results').on('click', '.show-faction-reputation-details', function () {
        $(this).parent().siblings('.faction-reputation-details').toggleClass('display-none')
    });

    // Match results options
    $("#game-content").on('click', '.hide-stats', async function () {

        // Select stats to show/hide
        let elements;
        let text = $(this).text();
        switch (text) {
            case 'Ovr.':
                elements = $('.match-result-overness');
                break;
            case 'XP':
                elements = $('.match-result-xp');
                break;
            case 'Pop.':
                elements = $('.match-result-popularity');
                break;
            case 'Gim.':
                elements = $('.match-result-gimmick-effectiveness');
                break;
            case 'Feuds':
                elements = $('.match-result-feuds');
                break;
            case 'Mor.':
                elements = $('.match-result-morale');
                break;
            case 'Fat.':
                elements = $('.match-result-fatigue');
                break;
        }

        if ($(this).hasClass('medium-grey')) {
            $(this).removeClass('medium-grey').addClass('extra-light-grey');
            elements.hide();
        }
        else {
            $(this).addClass('medium-grey').removeClass('extra-light-grey');
            elements.show();
        }

        // Save setting
        let setting = {};
        $('.hide-stats').each(function (i, e) {
            switch ($(e).text()) {
                case 'Ovr.':
                    setting.overness = $(e).hasClass('medium-grey');
                    break;
                case 'XP':
                    setting.xp = $(e).hasClass('medium-grey');
                    break;
                case 'Pop.':
                    setting.popularity = $(e).hasClass('medium-grey');
                    break;
                case 'Gim.':
                    setting.gimmickEffectiveness = $(e).hasClass('medium-grey');
                    break;
                case 'Feuds':
                    setting.feuds = $(e).hasClass('medium-grey');
                    break;
                case 'Mor.':
                    setting.morale = $(e).hasClass('medium-grey');
                    break;
                case 'Fat.':
                    setting.fatigue = $(e).hasClass('medium-grey');
                    break;
            }
        });
        globalUser.settings['matchResult'] = setting;
        await makeGameRequest(changeUserMatchResultSetting, {setting},
            function () {notie.alert({type: 4, text: 'Setting updated'})}, {}, false);
    });

    // Show championship contracts for cash in (during match)
    $("#match").on('click', '#championship-contract-cashin-show', async function () {
        let element = $(this);
        let teamType = $(this).attr('data-team-type');
        await makeGameRequest(getChampionshipContractHolders, {teamType},
            showGetChampionshipContractHoldersData, {element}, false);
    });

    // Show championships for cash in (during booking)
    $("#booking-talent-info").on('click', '#championship-contract-cashin-show', async function () {
        let element = $(this);
        let uid = $(this).attr('data-uid');
        await makeGameRequest(getChampionshipsForCashin, {uid}, showGetChampionshipsForCashinData,
            {element}, false);
    });

    // Cash in (during booking)
    $("#booking-talent-info").on('click', '#championship-contract-cashin', async function () {
        let championshipContractUid = $(this).attr('data-uid');
        let championshipUid = $(".championship-contract-cashin-box select[name='cashin-championships']").val();
        await makeGameRequest(addCashinFutureMatch, {championshipContractUid, championshipUid}, showAddCashinFutureMatchData,
            {}, false);
    });
});

async function showPlayMatchPage({matchesAndSegmentsData, index = 0, tournamentDisplay, cashinData} = {}) {
    const $matchInfoSelector = $("#match-info");
    const $match = $('#match');
    let stageLayers;

    // Get match
    let match = matchesAndSegmentsData[index];

    // Show header
    $('.match-container-header-text').text('Next Match');

    // Reset ui
    $matchInfoSelector.html('').removeClass('visibility-hidden').show();
    $match.data('played', false);

    // Show match info, participants text
    showMatchInfoText(match, matchesAndSegmentsData, index, cashinData['cashin'], cashinData['challenger'],
        cashinData['championshipContract']);
    $matchInfoSelector.fadeIn('slow');
    let largeTag = showMatchParticipantsText(match);
    $('.match-container').fadeIn('fast');

    // Reset booking talent info
    $('#booking-talent-info').html('');
    $('#booking-talent-info').addClass('match').hide();

    // Show cash in button
    if (match['canCashin']) {
        if ((match['type'] === 'singles' && cashinData['cashinSinglesAvailable']) ||
            (match['teamType'] === 'tag-team' && cashinData['cashinTagAvailable']) ||
            (match['teamType'] === 'trio' && cashinData['cashinTriosAvailable'])) {
            $match.append(
                '<button type="button" id="championship-contract-cashin-show" data-match-type="' + match['type'] + '" ' +
                'data-match-uid="' + match['uid'] + '" ' + 'data-team-type="' + match['teamType'] + '" ' +
                'class="button retro-button gold-button-background margin-top-20 margin-bottom-10 help-text margin-sides-auto display-block" ' +
                'title="Cash in a contract during or after this match">Cash In</button>'
            );
        }
    }

    // Add show match finishes and simulate buttons
    $('.show-match-finishes-button').remove();
    $('#simulate-match').remove();
    let matchFinishesButton = '';
    if (!globals.game.annualTournamentRunning) {
        // Don't show 'add finish' during annual tournament
        matchFinishesButton = '<div><button type="button" ' +
            'class="display-block show-match-finishes-button button retro-button margin-top-10 ' +
            'display-inline-block">Add Finish</button></div>';
    }
    $match.append('<div class="text-center match-buttons-container">' +
        '<div><button type="button" ' +
        'class="button retro-button margin-top-15 display-inline-block" id="simulate-match" ' +
        'data-match-uid="' + match['uid'] + '">Simulate</button></div>' +
        matchFinishesButton +
        '</div>'
    );

    // Add information box
    $match.append('<div class="match-superstar-information information-box">' +
        '<div class="superstar-info-match-container">' +
        'Participant Details' +
        '<div class="empty-superstar-info light-grey">' +
        '<div class="vertical-center">Hover over a Participant to display their details here</div>' +
        '</div>' +
        '</div>' +
        '</div>');

    // Show graphics
    if (match['graphics'].length > 0) {
        stageLayers = showPlayMatchPageGraphic(match);
    }

    // Show open challenge text
    if (match['consequence'] === 'random_opponent' && match['participants'].length < 2) {
        let text = ' is calling out anyone in the back to a match...';
        if (match['type'] === 'tag') {
            text = ' are calling out anyone in the back to a match...'
        }
        $matchInfoSelector.append(
            "<span class='font-bold display-block grey margin-top-5'>" +
            match['participants'][0]['name'] + text +
            "</span>"
        );
        $matchInfoSelector.append(
            "<span id='random-opponent-name' class='font-bold display-block dark-grey margin-top-5'>" +
            "Who\'s it going to be?" +
            "</span>"
        );

        // Don't allow playing
        $match.data('played', true);

        // Get random opponent
        await makeGameRequest(getRandomOpponent, {uid: match['uid'], type: match['type']},
            showGetRandomOpponentData, {}, false, true);

        function showGetRandomOpponentData({data} = {}) {
            if (!data['error']) {
                let randomOpponentDiv = $('#random-opponent-name');
                let available = shuffle(data['available']);
                let j = 0;
                let k = 0;
                let showAvailableOpponents = setInterval(function () {
                    // Show available opponents
                    randomOpponentDiv.text(available[j]);
                    j++;
                    if (j >= available.length) {
                        j = 0
                    }
                    k++;
                    if (k >= 30) {
                        // Show selected opponent
                        randomOpponentDiv.text(data['opponent']['name'] + ' answered the challenge!');
                        clearInterval(showAvailableOpponents);

                        setTimeout(function () {
                            // Add match wrestler element
                            let dataType = '';
                            if (match['type'] === 'tag') {
                                dataType = 'tagTeam'
                            }
                            let matchWrestlerElement = '<div class="match-wrestler-container">' +
                                '<button class="match-wrestler match-span" data-type="' +
                                dataType + '"' + ' data-name="' + data['opponent']['name'].replace(/"/g, "&quot;") + '">' +
                                getMatchOrSegmentParticipantName(data['opponent']) + '</button></div>';
                            $('#match').find('.match-wrestler-container').last().after(
                                '<span class="match-span">vs</span>' + matchWrestlerElement
                            );

                            // Update match data
                            match['participants'].push(data['opponent']);
                            match['graphics'] = data['graphics'];

                            // Update graphics
                            stageLayers = showPlayMatchPageGraphic(match);
                            $('#match-graphics').hide().fadeIn();

                            // Mark as not played
                            $('#match').data('played', false);
                        }, 500);
                    }
                }, 110, k);
            } else {
                if (data['error'] === 'no-opponents-found') {
                    notie.alert({
                        type: 3,
                        text: 'No opponents are available for this match. Try going back and deleting this match.'
                    });
                }
            }
        }
    }

    // Show gimmick match roulette text
    if (match['activeEffect'] === 'gimmick_match_roulette') {
        if (!match['gimmick']) {
            $matchInfoSelector.append(
                "<span id='random-gimmick-match-name' class='font-bold display-block dark-grey'>" +
                "The Roulette is spun ..." +
                "</span>"
            );
            $('#match').data('played', true);
            setTimeout(async function () {
                await makeGameRequest(getRandomGimmickMatch, {uid: match['uid']}, showGetRandomGimmickMatchData, {}, false, true);

                function showGetRandomGimmickMatchData({data} = {}) {
                    let randomGimmickMatchDiv = $('#random-gimmick-match-name');
                    let available = shuffle(data['available']);
                    let j = 0;
                    let k = 0;
                    let showAvailableGimmickMatches = setInterval(function () {
                        // Get random gimmick match
                        randomGimmickMatchDiv.text(available[j]);
                        j++;
                        if (j >= available.length) {
                            j = 0
                        }
                        k++;
                        if (k > 18) {
                            // Clear interval, set roulette to decelerating function
                            clearInterval(showAvailableGimmickMatches);
                            let l = 0;
                            let numberToRun = 6;

                            setDeceleratingTimeout(function () {
                                randomGimmickMatchDiv.text(available[j]);
                                j++;
                                if (j >= available.length) {
                                    j = 0
                                }
                                l++;
                                if (l >= numberToRun) {
                                    // Show selected gimmick match
                                    randomGimmickMatchDiv.text(data['gimmickMatch']['gimmick']);
                                    setTimeout(function () {
                                        let gimmickMatchName = data['gimmickMatch']['gimmick'];
                                        randomGimmickMatchDiv.text('The Roulette landed on ' + gimmickMatchName + ' Match!');

                                        // Show gimmick match name
                                        setTimeout(function () {
                                            let gimmickMatchText = getMatchGimmickText(data['gimmickMatch']);
                                            $('#match-info').append(
                                                "<span class='font-bold display-block margin-bottom-10 grey'>" + gimmickMatchText + " Match</span>"
                                            );
                                            match['gimmick'] = gimmickMatchName;
                                            match['generated'] = data['gimmickMatch']['generated'];
                                            randomGimmickMatchDiv.remove();
                                            $('#match').data('played', false);
                                        }, 1200);

                                    }, 1000)
                                }
                            }, 140, numberToRun);
                        }
                    }, 160, k);
                }
            }, 500);
        }
    }

    // Show pick winner notie
    if (!playMatchHintShown) {
        notie.alert({type: 4, text: '<span class="display-block">Click on a participant\'s name to pick them as the winner</span>', stay: true});
        playMatchHintShown = true;
    }

    // Show tournament display
    if (tournamentDisplay && match['tournamentRound']) {
        let tournamentMatchDisplay;

        // Add bracket
        let tournamentRound;
        let tournamentRounds;
        if (tournamentDisplay['type'] === 'elimination' || tournamentDisplay['stage'] === 'elimination') {
            tournamentRound = match['tournamentRound'];
            tournamentRounds = Object.keys(tournamentDisplay['bracket']).length;
            let bracket = tournamentDisplay['bracket'][tournamentRound];
            let bracketHtml = getTournamentBracketHtml(bracket, tournamentRound, tournamentRounds, false, tournamentDisplay['startRound']);
            tournamentMatchDisplay = '<div class="tournament-bracket-container font-bold text-left">'
                + bracketHtml + '</div>';
        }
        // Add table
        else if (tournamentDisplay['type'] === 'round-robin') {
            let table = tournamentDisplay['table'];
            let tableHtml = getTournamentGroupTableHtml(table, tournamentDisplay['participantsAdvancing']);
            tournamentMatchDisplay = '<div class="font-bold text-left margin-top-20 margin-bottom-20">'
                + tableHtml + '</div>';
        }
        $match.append(tournamentMatchDisplay);

        // Navigate bracket rounds
        if (tournamentDisplay['type'] === 'elimination') {
            $match.off('click', '.tournament-bracket-next');
            $match.off('click', '.tournament-bracket-prev');
            $match.on('click', '.tournament-bracket-next', function () {
                tournamentRound++;
                let bracket = tournamentDisplay['bracket'][tournamentRound];
                if (!bracket) {
                    tournamentRound--;
                    return false;
                }
                let bracketDiv = getTournamentBracketHtml(bracket, tournamentRound, tournamentRounds, false, tournamentDisplay['startRound']);
                $('.tournament-bracket-container').html(bracketDiv).hide().fadeIn('fast');
            });
            $match.on('click', '.tournament-bracket-prev', function () {
                tournamentRound--;
                let bracket = tournamentDisplay['bracket'][tournamentRound];
                if (!bracket) {
                    tournamentRound++;
                    return false;
                }
                let bracketDiv = getTournamentBracketHtml(bracket, tournamentRound, tournamentRounds, false, tournamentDisplay['startRound']);
                $('.tournament-bracket-container').html(bracketDiv).hide().fadeIn('fast');
            });
        }
    }

    // Cash in (during match)
    $("#match").off('click', '#championship-contract-cashin');
    $("#match").on('click', '#championship-contract-cashin', async function () {
        let matchUid = parseInt($(this).attr('data-match-uid'));
        let cashinTime = $(this).prev().val();
        let challengerUid = $(this).siblings('select[name="cashin-championships"]').val();
        await makeGameRequest(addCashinToMatch, {challengerUid, cashinTime, matchUid}, showAddCashinToMatchData,
            {cashinTime, challengerUid}, false);
    });

    function showAddCashinToMatchData({data, cashinTime} = {}) {
        if (cashinTime === "0") {
            $('.notie-textbox-inner').text('');

            if (data['error']) {
                if (data['error'] === 'no-women-allowed') {
                    notie.alert({type: 3, text: "Women are not allowed to be booked at this event"});
                }
                if (data['error'] === 'no-men-allowed') {
                    notie.alert({type: 3, text: "Men are not allowed to be booked at this event"});
                }
                if (data['error'] === 'challenger-not-found') {
                    notie.alert({type: 3, text: "The challenger could not be found"});
                }
                if (data['error'] === 'challenger-in-match') {
                    notie.alert({type: 3, text: "The challenger is already present in the match"});
                }
                return false;
            }

            // Add challenger to match participants
            let span = '<div class="match-wrestler-container">' +
                '<button class="match-wrestler match-span"' +
                ' data-name="' + data['challenger']['name'].replace(/"/g, "&quot;") + '">' +
                getMatchOrSegmentParticipantName(data['challenger']) + '</button></div>';
            if ($match.children('.match-wrestler-container').length > 4) {
                $match.find('.match-wrestler-container').last().after(span);
            } else {
                $match.find('.match-wrestler-container').last().after('<span class="match-span">vs</span>' + span);
            }
            match['participants'].push(data['challenger']);

            // Show cash in text
            let cashinText;
            if (data['challenger']['pronoun'] !== 'they') {
                cashinText = "{0} is cashing in {1}!".format(data['challenger']['name'], data['championshipContract']);
            } else {
                cashinText = "{0} are cashing in {1}!".format(data['challenger']['name'], data['championshipContract']);
            }
            $("#match-info").append(
                "<span class='font-bold display-block margin-bottom-5'>" + cashinText + "</span>"
            );

            // Set cash in checks
            cashinData['cashinSinglesAvailable'] = data['cashinSinglesAvailable'];
            cashinData['cashinTagAvailable'] = data['cashinTagAvailable'];
            cashinData['cashinTriosAvailable'] = data['cashinTriosAvailable'];

            // Show holy shit text
            let text = "<span class='display-block'>HOLY SHIT! The fans are going crazy for the cash-in! You've been awarded " +
                "<span class='blue margin-left-2 margin-right-3'><img alt='Points' src='static/www/static/cp_icon.png' class='points-image-small'/> 30</span>" +
                "</span>";
            notie.alert({type: 4, text: text, stay: true, append: true});

            // Refresh graphics
            match['graphics'] = data['graphics'];
            stageLayers = showPlayMatchPageGraphic(match);
            $('#match-graphics').hide().fadeIn();

            if (data['unreadMessages']) {
                let unreadMessages = data['unreadMessages'].toLocaleString('en');
                $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
                $('.messages-number').text(unreadMessages);
                $('#messages').hide().fadeIn('fast');
            }

            // Update points and fans
            updateGamePointsAndFans(data['points'], data['fans']);

            // Remove box
            $(".championship-contract-cashin-box").remove();
        }
        else if (cashinTime === "1") {
            if (data['error']) {
                if (data['error'] === 'no-women-allowed') {
                    notie.alert({type: 3, text: "Women are not allowed to be booked at this event"});
                }
                if (data['error'] === 'no-men-allowed') {
                    notie.alert({type: 3, text: "Men are not allowed to be booked at this event"});
                }
                if (data['error'] === 'challenger-not-found') {
                    notie.alert({type: 3, text: "The challenger could not be found"});
                }
                if (data['error'] === 'challenger-in-match') {
                    notie.alert({type: 3, text: "The challenger is already present in the match"});
                }
                return false;
            }

            $("#match-info").attr("data-cashin-challenger", data['challenger']['name']);
            $(".championship-contract-cashin-box").html(('<span class="font-bold">Cash-in added!</span>'));
        }
    }

    // Show information handler
    let timer;
    $match.off('mouseenter', '.match-wrestler');
    $match.on({
        mouseenter: function () {
            let $this = $(this);
            timer = setTimeout(function () {
                let selectedName = $this.attr('data-name');
                let member = match['participants'].filter(function (obj) {
                    return obj.name === selectedName;
                })[0];
                if (member) {
                    if ($this.attr('data-type') === 'tagTeam') {
                        showTagteamInformation(member, true);
                    }
                    else {
                        showSuperstarInformation(member, true);
                    }
                }
            }, 70);
        },
        mouseleave: function () {
            clearTimeout(timer);
        }
    }, ".match-wrestler");

    // Get match finishes
    $(document).off('click', '.show-match-finishes-button');
    $(document).on('click', '.show-match-finishes-button', async function () {
        if ($(this).text() === 'Add Finish') {
            await getMatchFinishes(match['uid']);
            $(this).text('Remove Finish');
        }
        else {
            $('.match-finishes-container').fadeOut();
            $(this).text('Add Finish');
        }
    });

    // Simulate handler
    $match.off('click', '#simulate-match');
    $match.on('click', '#simulate-match', async function () {
        if ($match.data('played')) {
            return;
        }
        let uid = parseInt($(this).attr('data-match-uid'));
        await makeGameRequest(simulateMatchWinnerRequest, {uid}, showSimulateMatchWinnerData, {}, false);

        async function showSimulateMatchWinnerData({data} = {}) {
            if (!data['error']) {
                let winnerNameFormatted = data['winnerName'].replace(/([ #;&,.+*~':"!^$[\]()=>|\/@])/g, '\\$1');
                let winnerDiv = $('#match .match-wrestler[data-name="' + winnerNameFormatted + '"]');
                if (!winnerDiv.length) {
                    winnerDiv = $(getRandomChoice($('#match .match-wrestler')));
                    if (typeof window.Sentry !== 'undefined') {
                        Sentry.captureMessage('Simulate Match: ' + winnerNameFormatted + ' not found');
                    }
                }
                await matchWinnerClick(winnerDiv, true);
            } else {
                if (data['error'] === 'match-not-found') {
                    notie.alert({
                        type: 3,
                        text: 'Match not found. Please try again or select a Participant.',
                        stay: true
                    });
                }
            }
        }
    });

    // Winner click handler
    $(document).off('click', '#match .match-wrestler');
    $(document).on({
        click: async function () {
            await matchWinnerClick($(this))
        }
    }, "#match .match-wrestler");

    async function matchWinnerClick(element, simulate) {
        if (element.hasClass('match-wrestler')) { // Check for click on match wrestler
            if ($match.data('played')) {
                return;
            }
            if (element.hasClass('disabled') && !simulate) {
                notie.alert({type: 4, text: "You cannot select winners at The Grand Invitational"});
                return;
            }

            // Get winner name
            let winnerName = element.attr('data-name');

            // After match cash in check
            cashinData['challengerName'] = '';
            let attrChallenger = $("#match-info").attr("data-cashin-challenger");
            if (typeof attrChallenger !== typeof undefined && attrChallenger !== false) {
                cashinData['challengerName'] = attrChallenger;
                $("#match-info").removeAttr("data-cashin-challenger");
            }

            if (match['uid'] === undefined || match['uid'] === null) {
                if (typeof window.Sentry !== 'undefined') {
                    Sentry.captureMessage(match)
                }
            }

            // Get match finish data
            let matchFinishData = {};
            if ($('.match-finishes-container').is(':visible')) {
                matchFinishData['name'] = $('.match-finishes-item-container.selected').data('name');

                // Get data for interfering roster member
                if ($('.match-finishes-interfering-member-select').is(':visible')) {
                    let matchFinishRosterMemberOption = $('.match-finishes-interfering-member-select select').find(":selected");
                    matchFinishData['interferingMemberUid'] = matchFinishRosterMemberOption.data('uid');
                    matchFinishData['interferingMemberType'] = matchFinishRosterMemberOption.data('type');
                }
            }

            await makeGameRequest(playMatch, {winnerName, uid: match['uid'], type: match['type'], cashinData,
                matchFinishData, graphics: match['graphics']}, showPlayMatchData, {match, winnerName,
                cashinData, tournamentDisplay, matchesAndSegmentsData, index, stageLayers, largeTag}, false);
        }
    }
}

function getMatchGimmickText(matchGimmick) {
    // Show generated objects
    if (matchGimmick['generated']['objectToClaim'] || matchGimmick['generated']['location']) {
        if (matchGimmick['generated']['objectToClaim']) {
            return '<span>' + matchGimmick['generated']['objectToClaim'] + ' on a Pole' + '</span>';
        }
        else if (matchGimmick['generated']['location']) {
            return '<span>' + matchGimmick['generated']['location'] + ' Brawl' + '</span>';
        }
    }
    else {
        return '<span>' + matchGimmick['gimmick'] + '</span>';
    }
}

async function getMatchFinishes(uid) {
    // Add match finishes container
    $('.match-finishes-container').remove();
    let matchFinishesContainer =
        '<div class="match-finishes-container box font-bold margin-sides-auto ' +
        '    margin-top-20 dark-grey text-left display-none">' +
        '    <div class="margin-bottom-15">' +
        '       <div class="match-finish-color">Match Finishes</div>' +
        '    </div>' +
        '        <div class="match-finishes-items-container"></div>' +
        '</div>';
    $('.match-buttons-container').after(matchFinishesContainer);

    await makeGameRequest(getAvailableMatchFinishes, {uid}, showGetAvailableMatchFinishesData,
        {uid}, false);
}

function getTournamentInjuryHtml(data) {
    let tournamentInjuryHtml = '';
    let tournamentNameText =
        '<span class="cyan">' +
        data["tournamentName"] + ' Tournament' +
        '</span>';

    if (data['type'] === 'elimination') {
        if (data['replacement']) {
            tournamentInjuryHtml =
                'Due to {0}\'s injury, {1} was replaced by {2} in the next round of the {3}'.format(data['injured'],
                    data['injuredPronoun'],
                    data['participantGoingThrough'], tournamentNameText)
        }
        else {
            tournamentInjuryHtml =
                'Due to {0}\'s injury, {1} progressed to the next round of the {2}'.format(data['injured'],
                    data['participantGoingThrough'],
                    tournamentNameText)
        }
    }
    else if (data['type'] === 'round-robin') {
        tournamentInjuryHtml =
            '{0} decided to fight through the injury and finish the {1}!'.format(data['injured'], tournamentNameText)
    }

    return tournamentInjuryHtml;
}

function getMatchParticipantClasses(superstar) {
    let classes = '';
    if (superstar['champion'] || superstar['championships'].length > 0) {
        classes += 'champion ';
    }
    if (superstar['partTimer']) {
        classes += 'part-timer ';
    }
    if (superstar['unhappy']) {
        classes += 'unhappy ';
    }
    if (globals.game.annualTournamentRunning) {
        classes += ' disabled';
    }
    return classes;
}

function showMatchInfoText(match, matchesAndSegmentsData, index, cashin, challenger, championshipContract) {
    const $matchInfoSelector = $("#match-info");

    // Main event indication
    if (index === matchesAndSegmentsData.length - 1) {
        let mainEventHtml = '<span class="light-grey font-0p925em">Main Event</span>';
        $matchInfoSelector.append(
            "<span class='font-bold display-block margin-bottom-2'>" + mainEventHtml + "</span>"
        );
    }

    // Add championship
    if (match['championships'].length > 0) {
        let championshipText = getChampionshipsDisplayName(match['championships']);
        $matchInfoSelector.append(
            "<span class='font-bold display-block gold margin-bottom-3'>" + championshipText + "</span>"
        );
    }

    // Show feud names and consequences
    let feudsHtmlArray = [];
    match['feuds'].forEach(function (feud) {
        let feudConsequenceHtml = '';
        if (feud['runBlowoff'] && feud['consequence']) {
            feudConsequenceHtml = ' ({0})'.format(toTitleCase(feud['consequence'].replace(/-/g, ' ')));
        }
        feudsHtmlArray.push("<span class='help-text' title='" + feud['participants'].join(' vs ').replace(/'/g, "&#39;") + "'>" +
            feud['name'] +
            feudConsequenceHtml +
            "</span>");
    });
    if (feudsHtmlArray.length > 0) {
        $matchInfoSelector.append(
            "<span class='font-bold display-block margin-bottom-3 faded-red-light'>" + commaSeparate(feudsHtmlArray, '&') + "</span>"
        );
    }

    // Show hype
    let matchHype = match['hype'];
    if (matchHype < 0) {
        matchHype = '- ' + (matchHype * -1)
    }
    else {
        matchHype = '+ ' + matchHype
    }
    $matchInfoSelector.append(
        "<span class='font-bold display-block medium-dark-grey margin-bottom-3'>" + matchHype + " HYPE</span>"
    );

    // Show bonuses
    let bonusesDivs = '';
    if (match['streakBonus']) {
        bonusesDivs += "<span class='font-bold display-block grey'>+ " + match['streakBonus'] + " Streak Bonus</span>";
    }
    if (match['eventBonus']) {
        let eventBonus = match['eventBonus'];
        if (eventBonus < 0) {
            eventBonus = '- ' + (eventBonus * -1)
        }
        else {
            eventBonus = '+ ' + eventBonus
        }
        bonusesDivs += "<span class='font-bold display-block grey'>" + eventBonus + " Match Effect Bonus</span>";
    }
    if (match['contractBonus']) {
        bonusesDivs += "<span class='font-bold display-block grey'>+ " + match['contractBonus'] + " Match Contract Bonus</span>";
    }
    if (match['tournamentFinalBonus']) {
        bonusesDivs += "<span class='font-bold display-block grey'>+ " + match['tournamentFinalBonus'] + " Tournament Final Bonus</span>";
    }
    if (bonusesDivs) {
        $matchInfoSelector.append('<div class="margin-bottom-2 line-height-1p4">' + bonusesDivs + '</div>');
    }

    // Add tournament information
    if (match['tournamentName']) {
        $matchInfoSelector.append(
            "<span class='font-bold display-block dark-grey'>" +
            match['tournamentName'] + ' ' + match['tournamentRoundName'] +
            "</span>"
        );
    }

    // Show gimmick text
    showMatchGimmickText(match);

    // Show cash in text if match is a weekly show cash in
    if (cashin) {
        let cashinText;
        if (match['type'] === 'singles') {
            cashinText = "{0} is cashing in {1}!".format(challenger, championshipContract);
        }
        else {
            cashinText = "{0} are cashing in {1}!".format(challenger, championshipContract);
        }
        $matchInfoSelector.append(
            "<span class='font-bold display-block grey'>" + cashinText + "</span>"
        );
        let text = "<span class='display-block'>HOLY SHIT! The fans are going crazy for the cash-in! You've been awarded " +
            "<span class='blue margin-left-2 margin-right-3'><img alt='Points' src='static/www/static/cp_icon.png' class='points-image-small margin-right-5'/>" +
            "30</span></span>";
        notie.alert({type: 4, text: text, stay: true, prepend: true});
    }
}

function showMatchGimmickText(match) {
    let matchTypeText;

    // Match type
    switch (match['participants'].length) {
        case 2:
            matchTypeText = '';
            break;
        case 3:
            matchTypeText = 'Triple Threat';
            break;
        case 4:
            matchTypeText = 'Fatal 4 Way';
            break;
        case 5:
            matchTypeText = '5 Way';
            break;
        case 6:
            matchTypeText = '6 Way';
            break;
        case 7:
            matchTypeText = '7 Way';
            break;
        case 8:
            matchTypeText = '8 Way';
            break;
        case 9:
            matchTypeText = '9 Way';
            break;
        case 10:
            matchTypeText = '10 Way';
            break;
        default:
            matchTypeText = '';
    }

    // Tag text
    let tagText = '';
    if (match['type'] === 'tag') {
        if (match['teamType'] === 'trio') {
            tagText = ' Trio '
        }
        else {
            tagText = ' Tag '
        }
    }

    // Singles tag text
    let singlesTagText = '';
    if (match['largerTag'] && match['teamType'] !== 'trio') {
        singlesTagText = match['largerTag'] + 'v' + match['largerTag'];
    }
    if (match['handicapSize']) {
        singlesTagText = '{0}v{1} '.format(match['handicapSize'][0], match['handicapSize'][1])
    }

    // Show gimmick match text
    if (match['gimmick']) {
        let gimmickMatchText = getMatchGimmickText(match);
        let refereeText = '';
        if (match['refereeName']) {
            refereeText = ' w/ ' + match['refereeName']
        }
        $("#match-info").append(
            "<span class='font-bold display-block grey match-gimmick-text'>" + matchTypeText + ' ' +
            singlesTagText + tagText + gimmickMatchText + " Match" + refereeText + "</span>"
        );
    }
    else {
        if (match['generated']['objectToClaim'] || match['generated']['location']) {
            $("#match-info").append(
                "<span class='font-bold display-block grey'>" + matchTypeText + ' ' +
                singlesTagText + tagText + " Match</span>"
            );
        }
    }
}

function setDeceleratingTimeout(callback, factor, times) {
    let internalCallback = function (tick, counter) {
        return function () {
            if (--tick >= 0) {
                window.setTimeout(internalCallback, ++counter * factor);
                callback(times);
            }
        }
    }(times, 0);

    window.setTimeout(internalCallback, factor);
}

function showMatchParticipantsText(match) {
    let largeTag = false;

    // Create x vs x vs x ... elements
    let participantElements = [];
    if (match['participants'].length > 10) {
        $('#match').css('text-align', 'left');
        match['participants'].forEach(function (participant) {
            let classes = getMatchParticipantClasses(participant);
            let dataType = '';
            if (match['type'] === 'tag') {
                dataType = 'tagTeam'
            }
            participantElements.push(
                '<div class="match-wrestler-container-battle-royal">' +
                '<div class="match-wrestler match-span-small ' + classes + '" data-type="' +
                dataType + '"' + ' data-name="' + participant['name'].replace(/"/g, "&quot;") + '" tabindex="0">' +
                participant['name'] + '</div></div>');
        });
    }
    else {
        $('#match').css('text-align', 'center');
        if (match['largerTag'] && match['teamType'] !== 'trio') {
            largeTag = true;
            match['participants'].forEach(function (participant) {
                let classes = getMatchParticipantClasses(participant);
                let dataType = '';
                if (match['type'] === 'tag') {
                    dataType = 'tagTeam'
                }
                let matchWrestlerText = getMatchOrSegmentParticipantName(participant);
                participantElements.push('<div class="match-wrestler-container">' +
                    '<button type="button" class="match-wrestler match-span-large-tag ' + classes + '" data-type="' +
                    dataType + '"' + ' data-name="' + participant['name'].replace(/"/g, "&quot;") + '">' +
                    matchWrestlerText + '</button></div>');
            });
        }
        else {
            match['participants'].forEach(function (participant) {
                let classes = getMatchParticipantClasses(participant);
                let dataType = '';
                if (match['type'] === 'tag') {
                    dataType = 'tagTeam'
                }
                let matchWrestlerText = getMatchOrSegmentParticipantName(participant);
                participantElements.push('<div class="match-wrestler-container">' +
                    '<button type="button" class="match-wrestler match-span ' + classes + '" data-type="' +
                    dataType + '"' + ' data-name="' + participant['name'].replace(/"/g, "&quot;") + '">' +
                    matchWrestlerText + '</button></div>');
            });
        }
    }

    // Add match text
    let matchText;
    if (match['participants'].length > 4) {
        matchText = participantElements.join('');
    }
    else {
        if (match['largerTag'] && match['teamType'] !== 'trio') {
            matchText = participantElements.join('<span class="match-span match-vs-small">vs</span>');
        }
        else {
            matchText = participantElements.join('<span class="match-span dark-grey margin-top-2">vs</span>');
        }
    }
    $('#match').html(matchText).show();

    return largeTag;
}

function showGetAvailableMatchFinishesData({data, uid} = {}) {
    if (!data['error']) {
        // Show match finishes container
        $('.match-finishes-container').fadeIn();

        // Add match finish items
        let matchFinishItemsHtml = '';
        let dustyMatchFinishes = '';
        let otherMatchFinishes = '';
        let specialMatchFinishes = '';

        data['matchFinishes'].forEach(function (matchFinish) {
            if (matchFinish['category'] === 'dusty') {
                dustyMatchFinishes += getMatchFinishItemHtml(matchFinish);
            } else if (matchFinish['category'] === 'other') {
                otherMatchFinishes += getMatchFinishItemHtml(matchFinish);
            } else if (matchFinish['category'] === 'special') {
                specialMatchFinishes += getMatchFinishItemHtml(matchFinish);
            }
        });

        matchFinishItemsHtml +=
            '<div class="match-finishes-category-container">' +
            '<div class="display-block margin-bottom-5 match-finishes-label">' +
            '    <span class="light-grey margin-left-2">Dusty</span>' +
            '</div>' +
            dustyMatchFinishes +
            '</div>' +

            '<div class="match-finishes-category-container">' +
            '<div class="display-block margin-bottom-5 margin-top-10 match-finishes-label">' +
            '    <span class="light-grey margin-left-2">Other</span>' +
            '</div>' +
            otherMatchFinishes +
            '</div>' +

            '<div class="match-finishes-category-container">' +
            '<div class="display-block margin-bottom-5 margin-top-10 match-finishes-label">' +
            '    <span class="light-grey margin-left-2">Special</span>' +
            '</div>' +
            specialMatchFinishes +
            '</div>';

        // Show match finish items
        $('.match-finishes-items-container').scrollTop(0);
        $('.match-finishes-items-container').html(matchFinishItemsHtml);

        // Select Match Finish
        $(document).off('click', '.match-finishes-item-container');
        $(document).on('click', '.match-finishes-item-container', async function () {
            playSoundEffect('success');

            // Hide other items and information
            $('.match-finish-item-information').hide();
            $('.match-finishes-item-container').hide();
            $('.match-finishes-interfering-member-select').remove();

            let $this = $(this);
            if ($this.hasClass('selected')) {
                // Deselect this item
                $this.removeClass('selected');

                // Show labels
                $('.match-finishes-label').show();

                // Show other items
                $('.match-finishes-item-container').promise().done(function () {
                    $('.match-finishes-item-container').hide().fadeIn();
                });
            } else {
                // Select this option
                $this.addClass('selected');

                // Hide labels
                $('.match-finishes-label').hide();

                // Show this option
                $this.find('.match-finish-item-information').show();
                $('.match-finishes-item-container').promise().done(async function () {
                    $this.fadeIn('fast');
                    $('.match-finishes-items-container').scrollTop(0);

                    // Show roster member select if applicable
                    if ($this.data('get-roster-members')) {
                        await makeGameRequest(getRosterMembersForInterference, {uid},
                            showGetRosterMembersForInterferenceData, {}, false, true);
                    }
                });
            }

            // Tutorial action check
            checkTutorialStepAction('click_match_finish_item');
        });

        // Tutorial action check
        checkTutorialStepAction('click_add_finish_button');
    }
    else {
        if (data['error'] === 'match-not-found') {
            notie.alert({type: 3, text: 'Match not found. Please try again.', stay: true});
        }
    }
}

function getMatchFinishPenaltyHelpText(name) {
    switch (name) {
        case 'Indecisive Blowoff':
            return 'Using a finish that is not clean adds a penalty to Feud Blowoffs.';
        case 'Problematic Finish':
            return 'Using a finish that is not clean adds a penalty to Gimmick Matches.';
        case 'Finish Already Held':
            return 'Using a finish that is not clean and has already been held at the Event or in the Feud adds a penalty.';
        default:
            return 'Alternate Match finishes can add a penalty or boost to the Match\'s rating.';
    }
}

function getMatchFinishItemHtml(matchFinishItem) {
    // Get affect record
    let affectRecord;
    if (matchFinishItem['affectRecord']) {
        affectRecord = '<div>Record Affected</div>'
    }
    else {
        affectRecord = '<div class="light-grey">Record Not Affected</div>'
    }

    // Get affect morale
    let affectMorale;
    if (matchFinishItem['affectMorale']) {
        affectMorale = '<div>Morale Affected</div>'
    }
    else {
        affectMorale = '<div class="light-grey">Morale Not Affected</div>'
    }

    // Get title change
    let titleChanges;
    if (matchFinishItem['changeChampionship']) {
        titleChanges = '<div>Title Changes Hands</div>'
    }
    else {
        titleChanges = '<div class="light-grey">No Title Change</div>'
    }

    // Get rating html
    let ratingPenalty;
    let ratingWord;
    let ratingIcon;
    if (matchFinishItem['ratingEffect'] < 0) {
        ratingPenalty = matchFinishItem['ratingEffect'] * -1;
        ratingWord = 'Penalty';
        ratingIcon = '<i class="fa fa-angle-double-down margin-right-3 top-1px font-17px"></i>';
    }
    else {
        ratingPenalty = matchFinishItem['ratingEffect'];
        ratingWord = 'Boost';
        ratingIcon = '<i class="fa fa-angle-double-up margin-right-3 top-1px font-17px"></i>';
    }
    let ratingHtml = getMatchFinishItemRatingHtml(ratingPenalty);
    let ratingPenaltyHtml =
        '<div>' +
            ratingIcon +
            '<span class="margin-right-5 margin-left-3">' + ratingHtml + '</span>' +
            'Rating ' + ratingWord +
        '</div>';

    // Get staleness effect
    let feudStaleness =
        '<div class="help-text" title="The amount this finish adds to a Feud\'s staleness. A normal match adds +1.">' +
            '<span class="margin-right-2 font-16px top-1px">+</span>' +
            matchFinishItem['feudStalenessEffect'] +
            ' Feud Staleness' +
        '</div>';

    // Get win/loss multipliers
    let lossMultiplier;
    if (matchFinishItem['lossMultiplier'] >= 0) {
        lossMultiplier = '<span class="dark-red margin-left-3">{0}<span class="margin-left-1">%</span> Loss</span>'.format(matchFinishItem['lossMultiplier'] * 100)
    }
    else {
        lossMultiplier = '<span class="green margin-left-3">{0}<span class="margin-left-1">%</span> Loss</span>'.format(matchFinishItem['lossMultiplier'] * -100)
    }

    let winMultiplier = '<span class="green margin-right-3">{0}<span class="margin-left-1">%</span> Win</span>'.format(matchFinishItem['winMultiplier'] * 100);

    let winLossMultiplierHtml = '<div class="help-text" title="The percentage this finish reduces the win/loss ' +
        'Popularity and Overness changes to.">' +
        winMultiplier + lossMultiplier +
        '</div>';

    // Get requirements
    let requirementsHtml = '';
    if (matchFinishItem['requirements']) {
        let formattedRequirements = Array.from(matchFinishItem['requirements'], function (x) {
            return toTitleCase(x.replace(/_/g, ' '))
        });
        let requirementsText = formattedRequirements.join(', ');
        requirementsHtml =
            '<div class="sky-blue width-95 margin-top-10 line-height-1p4">' +
                '<span>' +
                    requirementsText +
                '</span>' +
            '</div>';
    }

    // Get consequences
    let consequencesHtml = '';
    if (matchFinishItem['consequences']) {
        let formattedRequirements = Array.from(matchFinishItem['consequences'], function (x) {
            return toTitleCase(x.replace(/_/g, ' '))
        });
        let consequencesText = formattedRequirements.join(', ');
        consequencesHtml =
            '<div class="faded-red-light width-95 margin-top-5 line-height-1p4">' +
                '<span>' +
                    consequencesText +
                '</span>' +
            '</div>';
    }

    let monthsToReuseHtml = '';
    if (matchFinishItem['monthsToReuse']) {
        let monthsWord = getMonthsWord(matchFinishItem['monthsToReuse']);
        let monthsToReuseText = '{0} {1} to re-use'.format(matchFinishItem['monthsToReuse'], monthsWord);
        monthsToReuseHtml =
            '<div class="width-95 light-grey line-height-1p4 margin-top-5">' +
                '<span>' +
                    monthsToReuseText +
                '</span>' +
            '</div>';
    }

    // Get roster members attribute
    let getRosterMembers = 'false';
    if (matchFinishItem['interference']) {
        getRosterMembers = 'true'
    }

    // Get unavailability, add class
    let unavailableClass = '';
    if (matchFinishItem['unavailable']) {
        unavailableClass = ' unavailable'
    }

    return '<div class="match-finishes-item-container' + unavailableClass +
            '" data-name="' + matchFinishItem['name'] + '" data-get-roster-members="' + getRosterMembers + '">' +
            matchFinishItem['name'] +
            '<span class="float-right blue">' +
                '<img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small margin-right-5"/>' + matchFinishItem['cost'] +
            '</span>' +

            '<div class="match-finish-item-information display-none margin-top-8 margin-bottom-3 medium-grey">' +
                '<div class="medium-light-grey line-height-1p4 margin-bottom-10 width-95">' + matchFinishItem['description'] + '</div>' +
                '<div class="column-left">' +
                    affectRecord + affectMorale + titleChanges +
                '</div>' +
                '<div class="column-right">' +
                    ratingPenaltyHtml + feudStaleness + winLossMultiplierHtml +
                '</div>' +
                '<div class="clear"></div>' +
                requirementsHtml + consequencesHtml + monthsToReuseHtml +
            '</div>' +

        '</div>';
}

function getMatchFinishItemRatingHtml(rating) {
    let ratingValue = rating;
    let ratingFloor = Math.floor(ratingValue);
    let decimalRating = ratingValue - ratingFloor;
    let ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
    if (decimalRating) {
        if (decimalRating === 0.75) {
            decimalRating = 0.70;
        }
        else if (decimalRating === 0.25) {
            decimalRating = 0.35;
        }
        ratingText += '<i class="star star-under fa fa-star">' +
            '<i class="star star-over fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' +
            '</i>';
    }
    return ratingText;
}

function showGetRosterMembersForInterferenceData({data} = {}) {
    if (!data['error']) {
        let interferingMemberSelectHtml = '<option disabled selected value>Select Interfering Member</option>';

        // Add match managers if present
        if (data['matchManagers'].length > 0) {
            let matchManagersOptions = '';
            data['matchManagers'].forEach(function (matchManagers) {
                matchManagersOptions += '<option data-uid="' + matchManagers['uid'] +
                    '" data-type="' + matchManagers['type'] + '">' +
                    matchManagers['name'] + '</option>';
            });
            interferingMemberSelectHtml += '<optgroup label="Match Managers">' + matchManagersOptions + '</optgroup>';
        }

        // Add roster members
        let rosterMembersOptions = '';
        data['rosterMembers'].forEach(function (rosterMember) {
            rosterMembersOptions += '<option data-uid="' + rosterMember['uid'] +
                '" data-type="' + rosterMember['type'] + '">' +
                rosterMember['name'] + '</option>';
        });
        interferingMemberSelectHtml += '<optgroup label="Talent">' + rosterMembersOptions + '</optgroup>';

        let interferingMemberSelect =
            '<div class="match-finishes-interfering-member-select margin-top-5">' +
            '    <select name="name">' + interferingMemberSelectHtml + '</select>' +
            '</div>';

        $('.match-finishes-container').append(interferingMemberSelect);
    } else {
        if (data['error'] === 'match-not-found') {
            notie.alert({type: 3, text: 'Match not found. Please try again.', stay: true});
        }
    }
}

function showPlayMatchData({data, match, winnerName, cashinData, tournamentDisplay, matchesAndSegmentsData, index,
                            stageLayers, largeTag} = {}) {
    if (!data['error']) {
        const $match = $('#match');

        // Mark match as played
        $match.data('played', true);

        // Update graphics if updated in data
        if (data['graphics']) {
            match['graphics'] = data['graphics'];
            stageLayers = showPlayMatchPageGraphic(match);
        }

        // Add losing layer, pop changes
        turnMatchOrSegmentLoserGraphicOpaque(match, winnerName, stageLayers);
        showMatchPopularityChanges(data, match, winnerName, largeTag);

        // Show match result
        showMatchResult(data, match, cashinData['cashin'], cashinData['championshipContract']);

        // Show updates
        showMatchUpdates(data, match);
        showUpdatesContainers();
        animateGimmickEffectiveness();
        updateGamePointsAndFans(data['points'], data['fans']);

        // Reset gimmick match background
        $match.css({"background": "none"});

        // If after match cash in, add new match to matches array
        if (data['createdMatch']) {
            matchesAndSegmentsData.splice(index + 1, 0, data['createdMatch']);
        }

        // Increase index
        index++;

        // If new matches added (for tournament), add to matches variable
        if (data['matches']) {
            matchesAndSegmentsData = data['matches'];
            index = 0;  // Reset match counter, as data contains matches not held
        }

        // Update tournamentDisplay
        if (data['tournamentDisplay']) {
            tournamentDisplay = data['tournamentDisplay'];
        }

        // Update cashin data
        if (data['challenger']) {
            cashinData['challenger'] = data['challenger'];
            cashinData['championshipContract'] = data['championshipContract'];
            cashinData['cashin'] = true;
        } else {
            cashinData['challenger'] = '';
            cashinData['championshipContract'] = '';
            cashinData['cashin'] = '';
        }

        // Show 'continue' button, hide simulate and show finishes buttons, cash in box
        $('.match-superstar-information').before('<button type="button" class="button retro-button margin-top-15 ' +
            'margin-sides-auto display-block grey-button-background" ' +
            'id="progress-segment-button">Continue</button>');
        $('#simulate-match').hide();
        $('.show-match-finishes-button').hide();
        $('.match-finishes-container').hide();
        $(".championship-contract-cashin-box").remove();
        $("#championship-contract-cashin-show").remove();

        // Progress match handler
        $match.off('click', '#progress-segment-button');
        $match.on('click', '#progress-segment-button', async function () {
            if ($(this).hasClass('disabled')) {
                notie.alert({type: 4, text: "Please finish the current action before proceeding"});
                return false;
            }

            await showPlayMatchOrSegmentPage({data: {'matchesAndSegmentsData': matchesAndSegmentsData,
                    'cashinData': cashinData, 'tournamentDisplay': tournamentDisplay},
                index});

            // Tutorial action check
            checkTutorialStepAction('click_match_continue');
        });

        // Show injury replacement dialog for annual tournament
        if (data['annualTournamentDialogData']) {
            showNPCDialog(data['annualTournamentDialogData']);

            // Disable continue button
            $('#progress-segment-button').addClass('disabled');
        }

        // Tutorial action check
        if (data['nextTutorialState']) {
            globals.game.tutorialState = data['nextTutorialState']
        }
        // Tutorial action check
        checkTutorialStepAction('click_match_wrestler');
        checkTutorialStepAction('click_simulate_button');
    }
    else {
        let errorText;
        if (data['error'] === 'team-members-not-found') {
            errorText = 'Team members could not be found for {0}. Try removing this Match.'.format(data['teamName']);
        } else if (data['error'] === 'indecisive-finish-gimmick-match') {
            errorText = 'Indecisive Finishes cannot be used in Gimmick Matches';
        } else if (data['error'] === 'indecisive-finish-tournament-final') {
            errorText = 'Indecisive Finishes cannot be used in Tournament Finals';
        } else if (data['error'] === 'draw-elimination-tournament') {
            errorText = 'Match Finishes that result in draws cannot be used in Elimination Tournaments';
        } else if (data['error'] === 'match-finish-points') {
            errorText = 'You do not have enough Creative Points to add this Match Finish'
        } else if (data['error'] === 'match-finish-reuse-not-available') {
            let monthsWord = getMonthsWord(data['monthsToReuse']);
            errorText = "Special Finishes can only be used once every 6 months. This Finish can be re-used in {0} {1}.".format(data['monthsToReuse'], monthsWord);
        } else if (data['error'] === 'manager-finish-paid') {
            errorText = 'Manager Finishes are only available in JoW Paid';
        } else if (data['error'] === 'requirement-fail') {
            switch (data['requirement']) {
                case 'face_vs_heel':
                    errorText = "One Participant needs to have 'Face' Alignment and the other needs to have 'Heel' Alignment";
                    break;
                case 'face_winner':
                    errorText = "The participant with 'Face' Alignment needs to win the Match";
                    break;
                case 'heel_loser':
                    errorText = "The participant with 'Heel' Alignment needs to lose the Match";
                    break;
                case 'hot_feud':
                    errorText = "This Match needs to contain a Feud that is 'Hot'";
                    break;
                case 'title_match':
                    errorText = "A Championship needs to be contested in this Match";
                    break;
                case 'main_event':
                    errorText = "This Match needs to be the last Match on the show";
                    break;
                case 'loser_has_manager':
                    errorText = "The loser needs to have a manager assigned to them";
                    break;
                case 'winner_has_no_manager':
                    errorText = "The winner cannot have a Manager assigned or be a Full-time Manager";
                    break;
                case 'one-on-one-match':
                    errorText = "This Match Finish only be used in one on one Matches";
                    break;
                case 'level_2_producer':
                    errorText = "You need to have a Level 2 Producer available on your Staff";
                    break;
                case 'level_3_producer':
                    errorText = "You need to have a Level 3 Producer available on your Staff";
                    break;
                default:
                    errorText = "This Match doesn't fulfill the requirements for this Match Finish"
            }
        } else {
            errorText = 'There was an error playing this Match';
        }
        notie.alert({type: 3, text: errorText});
    }
}

function showMatchResult(data, match, cashin, championshipContract) {
    let eventResultsSelector = $("#event-match-results");
    let matchResultHtml = getMatchResultHtml(data, cashin, championshipContract, match);
    eventResultsSelector.find('.empty-event-match-results-text').remove();
    eventResultsSelector.find('.event-results-header').after(
        '<div class="margin-bottom-20 match-result" tabindex="0">' +
        matchResultHtml +
        '</div>'
    );
}

function getMatchResultHtml(data, cashin, championshipContract, match) {
    // Load match result settings
    let matchResultSetting = globalUser.settings['matchResult'];
    let XPClass = 'match-result-xp';
    let overnessClass = 'match-result-overness';
    let popularityClass = 'match-result-popularity';
    let feudsClass = 'match-result-feuds';
    let gimmickEffectivenessClass = 'match-result-gimmick-effectiveness';
    let moraleClass = 'match-result-morale';
    let fatigueClass = 'match-result-fatigue';
    if (matchResultSetting) {
        if (!matchResultSetting.xp) {
            XPClass += ' display-none'
        }
        if (!matchResultSetting.overness) {
            overnessClass += ' display-none'
        }
        if (!matchResultSetting.popularity) {
            popularityClass += ' display-none'
        }
        if (!matchResultSetting.gimmickEffectiveness) {
            gimmickEffectivenessClass += ' display-none'
        }
        if (!matchResultSetting.feuds) {
            feudsClass += ' display-none'
        }
        if (matchResultSetting.morale === false) {
            moraleClass += ' display-none'
        }
        if (!matchResultSetting.fatigue) {
            fatigueClass += ' display-none'
        }
    }
    else {
        XPClass += ' display-none';
        gimmickEffectivenessClass += ' display-none';
        fatigueClass += ' display-none';
    }

    // Get winner data
    let gimmickEffectivenessChange = '';
    if (data['winner']['gimmickEffectivenessChange']) {
        let prefix = '+ ';
        if (data['winner']['gimmickEffectivenessChange'] < 0) {
            prefix = '- ';
            data['winner']['gimmickEffectivenessChange'] *= -1;
        }
        gimmickEffectivenessChange = '<span class="character-label margin-left-8 ' + gimmickEffectivenessClass + ' help-text" title="Gimmick Overness Change">' +
            prefix + data['winner']['gimmickEffectivenessChange'] + '<span class="margin-left-2">%</span></span>'
    }

    let overnessChange = '';
    let winnerOvernessChange = data['winner']['overnessChange'];
    if (winnerOvernessChange) {
        let prefix = '+ ';
        if (winnerOvernessChange < 0) {
            prefix = '- ';
            winnerOvernessChange *= -1;
            overnessChange = '<span class="stale-color margin-left-8 ' + overnessClass + ' help-text" title="Overness Change">' + prefix +
                winnerOvernessChange + '<span class="margin-left-2">%</span></span>'
        }
        else {
            overnessChange = '<span class="hot-color margin-left-8 ' + overnessClass + ' help-text" title="Overness Change">' + prefix +
                winnerOvernessChange + '<span class="margin-left-2">%</span></span>'
        }
    }

    let hotOrStaleIcon = '';
    if (data['winner']['hot']) {
        hotOrStaleIcon = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5 help-text ' + overnessClass +
            '" title="Being Over boosts ' +
            ' a Superstar\'s Workrate, Popularity changes and Gimmick Effectiveness changes in Matches.">';
    }
    else if (data['winner']['stale']) {
        hotOrStaleIcon = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5 help-text ' + overnessClass +
            '" title="Being Stale' +
            ' lowers the ratings of a Superstar\'s Segments and their Popularity gains.">'
    }

    // Morale change
    let moraleChange = '';
    let winnerMoraleChange = data['winner']['moraleChange'];
    if (winnerMoraleChange) {
        let prefix = '+ ';
        if (winnerMoraleChange < 0) {
            prefix = '- ';
            winnerMoraleChange *= -1;
            moraleChange = '<span class="margin-left-8 morale-dissatisfied-color ' + moraleClass + ' help-text" title="Morale Change">' + prefix +
                winnerMoraleChange + '<span class="margin-left-2">%</span></span>'
        }
        else {
            moraleChange = '<span class="margin-left-8 light-green ' + moraleClass + ' help-text" title="Morale Change">' + prefix +
                winnerMoraleChange + '<span class="margin-left-2">%</span></span>'
        }
    }

    // XP gained
    let xpGained = '<span class="workrate-blue ' + XPClass + ' margin-left-8 help-text" title="XP Change">+ ' + data['winner']['xpGained'] + ' XP</span>';

    // Fatigue change
    let fatigueChange = '';
    if (data['winner']['fatigueChange'] !== undefined) {
        fatigueChange =
            '<span class="fatigue-yellow ' + fatigueClass + ' margin-left-8 help-text" title="Fatigue Change">+ ' +
            data['winner']['fatigueChange'] + '<span class="margin-left-2">%</span>' +
            '</span>';
    }

    // Popularity change
    let icon = 'fa-angle-double-up';
    if (data['winner']['popularityChange'] < 0) {
        icon = 'fa-angle-double-down';
        data['winner']['popularityChange'] *= -1;
    }
    let popColor = 'medium-dark-grey';
    if (data['hotMatch']) {
        popColor = 'hot-color'
    }
    let popularityChange = '<span class="' + popularityClass + '">' +
        '<span class="margin-left-8 grey">' + data['winner']['popularity'] + '</span>' +
        '<span class="' + popColor + ' margin-right-5 help-text" title="Popularity Change">' +
        '<i class="fa ' + icon + ' margin-left-8 margin-right-5"></i>' +
        data['winner']['popularityChange'] + '</span>' +
        '</span>';

    // Managers
    let managersHtml = getEventResultParticipantManagersHtml(data['winner']['managersData'], 'match');

    let winner = data['winner']['name'] +
        hotOrStaleIcon + xpGained + gimmickEffectivenessChange + overnessChange + moraleChange + fatigueChange +
        popularityChange + managersHtml;

    let winnerChampionshipText = '';
    let retainedChampionshipText = '';
    if (data['winner']['wonChampionships'].length > 0 && data['winner']['defendedChampionships'].length > 0) {
        winnerChampionshipText = '<span class="margin-left-5">to win the<span class="margin-left-5 gold flash-text">' +
            getChampionshipsDisplayName(data['winner']['wonChampionships']) + '</span></span>';
        winnerChampionshipText += '<span class="margin-left-5">and retain the<span class="margin-left-5 gold">' +
            getChampionshipsDisplayName(data['winner']['defendedChampionships']) + '</span></span>';
    }
    else {
        if (data['winner']['wonChampionships'].length > 0) {
            let championshipText = getChampionshipsDisplayName(data['winner']['wonChampionships']);
            winnerChampionshipText = '<span class="margin-left-5">to win the<span class="margin-left-5 gold flash-text">' +
                championshipText +
                '</span></span>';
        }
        else if (data['winner']['defendedChampionships'].length > 0) {
            let championshipText = getChampionshipsDisplayName(data['winner']['defendedChampionships']);
            winnerChampionshipText = '<span class="margin-left-5">to retain the<span class="margin-left-5 gold">' +
                championshipText +
                '</span></span>';
        }
        else if (data['winner']['retainedChampionships'].length > 0) {
            let championshipText = getChampionshipsDisplayName(data['winner']['retainedChampionships']);
            retainedChampionshipText = '<span class="display-block margin-top-5"><span class="gold">' +
                championshipText +
                '</span> did not change hands</span>';
        }
    }

    let losers = [];
    let losersHtml = '';
    data['losers'].forEach(function (loser) {
        let decrease = loser['popularityChange'] * -1;
        let icon = 'fa-angle-double-down';

        if (decrease >= 0) {
            icon = 'fa-angle-double-up';
            loser['popularityChange'] *= -1;
            if (data['hotMatch']) {
                icon += ' hot-label'
            }
        }

        let gimmickEffectivenessChange = '';
        if (loser['gimmickEffectivenessChange']) {
            let prefix = '+ ';
            if (loser['gimmickEffectivenessChange'] < 0) {
                prefix = '- ';
                loser['gimmickEffectivenessChange'] *= -1;
            }
            gimmickEffectivenessChange = '<span class="character-label margin-left-8 ' + gimmickEffectivenessClass + ' help-text" title="Gimmick Overness Change">' +
                prefix + loser['gimmickEffectivenessChange'] + '<span class="margin-left-2">%</span></span>'
        }

        let overnessChange = '';
        let loserOvernessChange = loser['overnessChange'];
        if (loserOvernessChange) {
            let prefix = '+ ';
            if (loserOvernessChange < 0) {
                prefix = '- ';
                loserOvernessChange *= -1;
                overnessChange = '<span class="stale-color ' + overnessClass + ' margin-left-8 help-text" title="Overness Change">' + prefix +
                    loserOvernessChange + '<span class="margin-left-2">%</span></span>'
            }
            else {
                overnessChange = '<span class="hot-color ' + overnessClass + ' margin-left-8 help-text" title="Overness Change">' + prefix +
                    loserOvernessChange + '<span class="margin-left-2">%</span></span>'
            }
        }

        let hotOrStaleIcon = '';
        if (loser['hot']) {
            hotOrStaleIcon = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5 help-text ' + overnessClass +
                '" title="Being Over boosts ' +
                ' a Superstar\'s Workrate, Popularity changes and Gimmick Effectiveness changes in Matches.">'
        }
        else if (loser['stale']) {
            hotOrStaleIcon = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5 help-text ' + overnessClass +
                '" title="Being Stale' +
                ' lowers the ratings of a Superstar\'s Segments and their Popularity gains.">'
        }

        // Morale change
        let moraleChange = '';
        let loserMoraleChange = loser['moraleChange'];
        if (loserMoraleChange) {
            let prefix = '+ ';
            if (loserMoraleChange < 0) {
                prefix = '- ';
                loserMoraleChange *= -1;
                moraleChange = '<span class="margin-left-8 morale-dissatisfied-color ' + moraleClass + ' help-text" title="Morale Change">' + prefix +
                    loserMoraleChange + '<span class="margin-left-2">%</span></span>'
            }
            else {
                moraleChange = '<span class="margin-left-8 light-green ' + moraleClass + ' help-text" title="Morale Change">' + prefix +
                    loserMoraleChange + '<span class="margin-left-2">%</span></span>'
            }
        }

        // Fatigue change
        let fatigueChange = '';
        if (loser['fatigueChange'] !== undefined) {
            fatigueChange =
                '<span class="fatigue-yellow ' + fatigueClass + ' margin-left-8 help-text" title="Fatigue Change">+ ' +
                loser['fatigueChange'] + '<span class="margin-left-2">%</span>' +
                '</span>'
        }

        // XP gained
        let xpGained = '<span class="workrate-blue ' + XPClass + ' margin-left-8 help-text" title="XP Change">+ ' + loser['xpGained'] + ' XP</span>';

        let popularityChange = '<span class="' + popularityClass + '">' +
            '<span class="margin-left-8 grey">' + loser['popularity'] + '</span>' +
            '<span class="' + popColor + ' margin-right-5 help-text" title="Popularity Change">' +
            '<i class="fa ' + icon + ' margin-left-8 margin-right-5"></i>' +
            loser['popularityChange'] +
            '</span>' +
            '</span>';

        // Managers
        let managersHtml = getEventResultParticipantManagersHtml(loser['managersData'], 'match');

        let loserArray =
            loser['name'] + hotOrStaleIcon + xpGained + gimmickEffectivenessChange + overnessChange + moraleChange +
            fatigueChange + popularityChange + managersHtml;
        losers.push(loserArray);
    });

    // Join losers with comma and 'and'
    if (losers.length > 1) {
        losersHtml = losers.slice(0, -1).join(', ') + ' <span class="light-grey">and</span> ' + losers.slice(-1);
    }
    else {
        losersHtml = losers[0];
    }

    // Match finish text
    let finishHtml = '';
    if (data['finishName']) {
        let finishText = '';
        if (data['finishText']) {
            finishText = '<span class="margin-left-5">by ' + data['finishText'] + '</span>';

            // Show popularity increase
            if (data['interferencePopularityIncrease']) {
                finishText +=
                    '<span class="help-text match-result-popularity" title="Popularity Change">' +
                    '<i class="fa fa-angle-double-up margin-left-8 margin-right-5"></i>' +
                    data['interferencePopularityIncrease'] +
                    '</span>';
            }

            // Show feud hype increase
            data['interferenceFeuds'].forEach(function(interferenceFeud) {
                finishText += getFeudHtml(interferenceFeud, 'match-result-feuds')
            });
        }

        let noContestText = '';
        if (data['matchFinish']['draw']) {
            noContestText = ' No Contest '
        }

        finishHtml = '<span class="margin-left-5 light-grey">' +
            noContestText + 'via <span class="match-finish-color">' + data['finishName'] + '</span>' +
            finishText +
            '</span>';
    }

    let cashinText = '';
    if (cashin) {
        cashinText = ' (' + championshipContract + ' Cash In) ';
    }
    let generatedText;
    if (data['generatedText']) {
        generatedText = '<span class="display-block generated-text">' + data['generatedText'] + '</span>';
    }

    // Set rating
    let rating;
    let ratingText;
    if (data['rating'] !== null) {
        let ratingValue = data['rating'];
        let ratingFloor = Math.floor(ratingValue);
        let decimalRating = ratingValue - ratingFloor;
        ratingText = '<i class="fa fa-star"></i>'.repeat(ratingFloor);
        if (decimalRating) {
            if (decimalRating === 0.75) {
                decimalRating = 0.70;
            }
            else if (decimalRating === 0.25) {
                decimalRating = 0.35;
            }
            ratingText += '<i class="star star-under fa fa-star">' +
                '<i class="star star-over fa fa-star" style="width: ' + decimalRating * 100 + '%"></i>' +
                '</i>';
            if (ratingFloor < 5) {
                ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor - 1);
            }
        }
        else {
            if (ratingFloor < 5) {
                ratingText += '<i class="fa fa-star star-under"></i>'.repeat(5 - ratingFloor);
            }
        }
        // Set rating element
        rating = '<span class="display-block match-star-rating margin-bottom-10">' +
            '<span class="dark-grey" role="text" aria-label="' + data['rating'] + ' stars' + '">' +
            ratingText +
            '</span></span>';
    }
    else {
        ratingText = 'No Rating';
        // Set rating element
        rating = '<span class="display-block margin-bottom-12">' +
            '<span class="grey font-0p925em">' +
            ratingText +
            '</span></span>';
    }

    // Set Gimmick match text
    let text;
    let matchGimmick = data['matchGimmick'];

    if (matchGimmick) {
        // Show generated text
        if (data['generatedText']) {
            if (match['rules'] === 'battle_royal') {
                text = "{0}{1} won the {2} match{3}{4}".format(generatedText, winner, matchGimmick, finishHtml, winnerChampionshipText);
            }
            else if (matchGimmick === 'Ironman') {
                text = "{0} <span class='light-grey'>def.</span> {1}{2} with a score of {3}{4}".format(winner,
                    losersHtml, finishHtml, data['generatedText'], winnerChampionshipText);
            }
            else {
                // 2/3 falls, elimination
                text = "{0}{1} <span class='light-grey'>def.</span> {2}{3}{4}{5}".format(generatedText, winner, losersHtml, finishHtml, winnerChampionshipText, cashinText);
            }
        }
        else if (match['refereeName']) {
            let refereeText = '<span class="medium-grey"> with Special Referee ' + match['refereeName'] + '</span>';
            text = "{0} <span class='light-grey'>def.</span> {1}{2}{3}{4}".format(winner, losersHtml, finishHtml, winnerChampionshipText, refereeText);
        }
        else if (matchGimmick === 'Steel Cage' || matchGimmick === 'Graphene Cage') {
            text = "{0} escaped the cage{1}, defeating {2}{3}".format(winner, winnerChampionshipText, losersHtml, finishHtml);
        }
        else if (matchGimmick === 'I Quit') {
            text = "{0} made {1} say 'I Quit'{2}{3}".format(winner,
                losersHtml, finishHtml, winnerChampionshipText);
        }
        else if (matchGimmick === 'Street Fight') {
            text = "{0} <span class='light-grey'>def.</span> {1}{2} in a violent street fight{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
        }
        else if (matchGimmick.includes('Ladder')) {
            text = "{0} climbed the ladder{1}, defeating {2}{3}".format(winner, winnerChampionshipText, losersHtml, finishHtml);
        }
        else if (matchGimmick === 'Pu Ladder') {
            text = "{0} climbed the plutonium ladder{1}, defeating {2}{3}".format(winner, winnerChampionshipText, losersHtml, finishHtml);
        }
        else if (matchGimmick === 'Pole') {
            text = "{0} grabbed the {1} off the pole{2}, defeating {3}{4}".format(winner,
                match['generated']['objectToClaim'], winnerChampionshipText, losersHtml, finishHtml);
        }
        else if (matchGimmick === 'Canyon Fight') {
            text = "{0} <span class='light-grey'>def.</span> {1}{2} in a violent canyon fight{3}".format(winner,
                losersHtml, finishHtml, winnerChampionshipText);
        }
        else if (matchGimmick === 'Glacier Escape') {
            text = "{0} escaped the glacier{1}, defeating {2}{3}".format(winner, winnerChampionshipText, losersHtml, finishHtml);
        }
        else {
            text = "{0} <span class='light-grey'>def.</span> {1}{2}{3}".format(winner, losersHtml, finishHtml, winnerChampionshipText);
        }
    }
    // Get normal match text
    else {
        if (data['matchFinish'] && data['matchFinish']['draw']) {
            text = "{0} <span class='light-grey'>vs</span> {1}{2}{3}{4}".format(winner, losersHtml, finishHtml, winnerChampionshipText, cashinText);
        }
        else {
            text = "{0} <span class='light-grey'>def.</span> {1}{2}{3}{4}".format(winner, losersHtml, finishHtml, winnerChampionshipText, cashinText);
        }
    }

    // Feud Hypes
    let feudsHtml = '';
    data['feuds'].forEach(function (feud) {
        feudsHtml += getFeudHtml(feud, feudsClass);
    });

    // Penalties/Boosts
    let boostHtml = '';
    if (data['ratingData']['unhappySuperstarsPenalty']) {
        let unhappyPenalty = data['ratingData']['unhappySuperstarsPenalty'];
        let ratingHtml = '<i class="star star-under fa fa-star margin-left-5">' +
            '<i class="star star-over fa fa-star dark-red" style="width: ' + unhappyPenalty * 100 + '%"></i>' +
            '</i>';
        boostHtml += '<span class="display-block margin-bottom-5 help-text" title="Unhappy workers lower Match ratings.">' +
            '<span class="dark-red line-height-1p4">' +
            '<i class="fa fa-angle-double-down margin-right-5"></i>Unhappy Worker' + ratingHtml + '</span></span>';
    }
    if (data['ratingData']['workableInjuryPenalty']) {
        let injuredPenalty = data['ratingData']['workableInjuryPenalty'];
        let ratingHtml = getStarRatingHtml(injuredPenalty, 'dark-red', injuredPenalty);
        boostHtml += '<span class="display-block margin-bottom-5 help-text" title="Injured workers lower Match ratings.">' +
            '<span class="dark-red line-height-1p4">' +
            '<i class="fa fa-angle-double-down margin-right-5"></i><span class="margin-right-5">Injured Worker</span>' +
            ratingHtml + '</span></span>';
    }
    if (data['ratingData']['negativeBoostName']) {
        let negativeBoost = data['ratingData']['negativeBoostNumber'] * -1;
        let ratingHtml = '<i class="star star-under fa fa-star margin-left-5">' +
            '<i class="star star-over fa fa-star dark-red" style="width: ' + negativeBoost * 100 + '%"></i>' +
            '</i>';
        boostHtml += '<span class="display-block margin-bottom-5 help-text" title="Matches can sometimes get' +
            ' negative effects that lower their ratings.">' +
            '<span class="dark-red line-height-1p4">' +
            '<i class="fa fa-angle-double-down margin-right-5"></i>' +
            data['ratingData']['negativeBoostName'] + ratingHtml +
            '</span></span>';
    }
    if (data['ratingData']['positiveBoostName']) {
        let positiveBoost = data['ratingData']['positiveBoostNumber'];
        let ratingHtml = '<i class="star star-under fa fa-star margin-left-5">' +
            '<i class="star star-over fa fa-star green" style="width: ' + positiveBoost * 100 + '%"></i>' +
            '</i>';
        boostHtml += '<span class="display-block margin-bottom-5 help-text" title="Matches can sometimes get' +
            ' positive effects that increase their ratings.">' +
            '<span class="green line-height-1p4">' +
            '<i class="fa fa-angle-double-up margin-right-5"></i>' +
            data['ratingData']['positiveBoostName'] + ratingHtml +
            '</span></span>';
    }
    if (data['ratingData']['drewBloodBoost']) {
        let drewBloodBoost = data['ratingData']['drewBloodBoost'];
        if (drewBloodBoost === 0.75) {
            drewBloodBoost = 0.70;
        }
        else if (drewBloodBoost === 0.25) {
            drewBloodBoost = 0.35;
        }
        let ratingHtml = '<i class="star star-under fa fa-star margin-left-5">' +
            '<i class="star star-over fa fa-star green" style="width: ' + drewBloodBoost * 100 + '%"></i>' +
            '</i>';
        boostHtml += '<span class="display-block margin-bottom-5 help-text" title="Gimmick Matches have a small chance ' +
            'to draw blood, increasing a Match\'s Rating.">' +
            '<span class="green line-height-1p4">' +
            '<i class="fa fa-angle-double-up margin-right-5"></i>Blood' + ratingHtml + '</span></span>';
    }

    // Match finish effect
    if (data['ratingData']['matchFinishRatingData']) {
        data['ratingData']['matchFinishRatingData'].forEach(function (ratingEffect) {
            let matchFinishRatingEffect;
            let matchFinishRatingClass;
            let matchFinishRatingIcon;
            if (ratingEffect['number'] < 0) {
                matchFinishRatingEffect = ratingEffect['number'] * -1;
                matchFinishRatingClass = 'dark-red';
                matchFinishRatingIcon = '<i class="fa fa-angle-double-down margin-right-5"></i>';
            }
            else {
                matchFinishRatingEffect = ratingEffect['number'];
                matchFinishRatingClass = 'green';
                matchFinishRatingIcon = '<i class="fa fa-angle-double-up margin-right-5"></i>';
            }

            if (matchFinishRatingEffect === 0.75) {
                matchFinishRatingEffect = 0.70;
            }
            else if (matchFinishRatingEffect === 0.25) {
                matchFinishRatingEffect = 0.35;
            }

            let finishPenaltyHelpText = getMatchFinishPenaltyHelpText(ratingEffect['name']);
            let matchFinishRatingName = '<span class="margin-right-5">' + ratingEffect['name'] + '</span>';

            let ratingHtml = getStarRatingHtml(matchFinishRatingEffect, matchFinishRatingClass, matchFinishRatingEffect);
            boostHtml += '<span class="display-block margin-bottom-5 help-text" title="' + finishPenaltyHelpText + '">' +
                '<span class="line-height-1p4 ' + matchFinishRatingClass + '">' +
                matchFinishRatingIcon + matchFinishRatingName + ratingHtml +
                '</span></span>';
        })
    }

    return '<div class=col1>' +
        text + feudsHtml + retainedChampionshipText +
        '</div>' +
        '<div class="col2 text-right">' +
        rating + boostHtml +
        '</div>' +
        '<div class="clear"></div>';
}

function getFeudHtml(feud, feudsClass) {
    let hypeChange;
    if (feud['hypeChange'] < 0) {
        feud['hypeChange'] *= -1;
        hypeChange = '<i class="fa fa-angle-double-down margin-left-8 margin-right-8"></i>' +
            feud['hypeChange'];
    }
    else {
        hypeChange = '<i class="fa fa-angle-double-up margin-left-8 margin-right-8"></i>' +
            feud['hypeChange'];
    }

    let feudName = feud['name'];
    if (feud['ended']) {
        feudName += ' <span class="bright-red">Blowoff</span>';
    }
    let feudClass = 'faded-red-light';
    if (feud['hot']) {
        feudClass = 'hot-color'
    }

    return '<span class="margin-left-8 ' + feudsClass + '">' +
        '<span class="faded-red-light">' + feudName + '</span>' +
        '<span class="' + feudClass + '">' +
        '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' +
        feud['hype'] +
        '<span class="faded-red">' + hypeChange + '</span>' +
        '</span>' +
        '</span>';
}

function showMatchPopularityChanges(data, match, winnerName, largeTag) {
    // Show popularity changes next to wrestler's names
    $(".match-wrestler").each(function (index) {
        let wrestlerDiv = $(this);
        let wrestlerName = wrestlerDiv.attr('data-name');
        let singles = (data['losers'].length === 1);

        // Losers
        if (!(wrestlerName === winnerName)) {
            $(this).addClass('opaque');  // Darken losers' names

            // Show loser's change if participants are 10 or less
            if (match['participants'].length <= 10) {
                data['losers'].forEach(function (loser) {
                    if (wrestlerName === loser['name']) {
                        let decrease = loser['popularityChange'] * -1;

                        let color = 'dark-red';
                        if (decrease >= 0) {
                            color = 'green';
                            decrease = '+ ' + decrease
                        } else {
                            decrease = '- ' + loser['popularityChange']
                        }

                        // Show changes to the right and left if singles match
                        if (singles && !largeTag) {
                            if (index === 1) {
                                wrestlerDiv.parent().prepend('<div class="match-stat ' + color + '">  '
                                    + decrease + '</div>');
                            } else {
                                wrestlerDiv.parent().prepend('<div class="match-stat ' + color + '">  '
                                    + decrease + '</div>');
                            }
                        } else {
                            if (largeTag) {
                                wrestlerDiv.parent().prepend('<div class="match-stat-large-tag ' + color + '">  '
                                    + decrease + '</div>');
                            } else {
                                wrestlerDiv.parent().prepend('<div class="match-stat ' + color + '">  ' +
                                    decrease + '</div>');
                            }
                        }
                    }
                });
            }
        }
        // Winner
        else {
            // Show winner' changes if participants are 10  or less
            if (match['participants'].length <= 10) {
                let winner = data['winner'];
                let increase = winner['popularityChange'];

                let color = 'green';
                if (increase < 0) {
                    color = 'dark-red';
                    increase = '- ' + (winner['popularityChange'] * -1)
                } else {
                    increase = '+ ' + increase
                }

                if (singles && !largeTag) {
                    if (index === 1) {
                        $(this).parent().prepend('<div class="match-stat ' + color + '">'
                            + increase + '</div>');
                    } else {
                        $(this).parent().prepend('<div class="match-stat ' + color + '">' +
                            increase + '</div>');
                    }
                } else {
                    if (largeTag) {
                        $(this).parent().prepend('<div class="match-stat-large-tag ' + color + '">' +
                            increase + '</div>');
                    } else {
                        $(this).parent().prepend('<div class="match-stat ' + color + '">' +
                            increase + '</div>');
                    }
                }
            }
        }
    });

    // Show popularity change
    $('#match').find('.match-stat, .match-stat-large-tag').each(function () {
        $(this).hide().slideDown('slow');
    });

    // Find loser in tournament bracket
    if (match['tournamentRound'] && !match['tournamentGroup']) {
        // Check if right round selected in tournament bracket
        if (parseInt($('.tournament-round-name').attr('data-round-number')) === match['tournamentRound']) {
            let loserName;
            $('#match .match-wrestler').each(function (i, e) {
                if ($(e).attr('data-name') !== winnerName) {
                    loserName = $(e).attr('data-name');
                    return false;
                }
            });
            if (loserName) {
                // Add opaque class
                let loserTournamentElement = $('.tournament-participant-name[data-name="' +
                    loserName.replace(/([ #;&,.+*~':"!^$[\]()=>|\/@])/g, '\\$1') + '"]');
                if (loserTournamentElement.length > 0) {
                    loserTournamentElement.parent().addClass('opaque');
                }
            }
        }
    }
}

function showMatchUpdates(data, match) {
    let prestigeResultsSelector = $("#prestige-results");
    let eventUpdatesSelector = $(".event-updates-other .updates-container");
    let eventUpdatesAvailabilitySelector = $(".event-updates-availability .updates-container");
    let eventUpdatesOvernessSelector = $(".event-updates-overness .updates-container");
    let eventUpdatesGimmicksSelector = $(".event-updates-gimmicks .updates-container");
    let eventUpdatesFeudsSelector = $(".event-updates-feuds .updates-container");

    // If holy shit text, show it
    let holyShitText;
    if (data['holyShitData']) {
        let holyShitData = data['holyShitData'];
        let overnessIncrease = '<span class="hot-color margin-left-2 margin-right-3">' + holyShitData['overnessIncrease'] +
            '<span class="margin-left-2">%</span></span>';

        let pointsAwardedHtml = '';
        if (holyShitData['pointsGained']) {
            let pointsGained = '<span class="blue margin-left-2 margin-right-3"><img alt="Points" src="static/www/static/cp_icon.png" class="points-image-small four-px"/> ' +
                holyShitData['pointsGained'] + '</span>';
            pointsAwardedHtml = 'You\'ve been awarded ' + pointsGained + ' and ';
        }

        holyShitText = '<span class="display-block generated-text">' +
            '<span class="holy-shit-text">' + 'HOLY SHIT! ' + '</span>' +
            holyShitData['text'] + ' The fans are going crazy. ' + pointsAwardedHtml +
            holyShitData['superstarName'] + ' gained an Overness boost of ' + overnessIncrease +
            '.</span>';

        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12">' +
            holyShitText +
            '</span>'
        );
        setTimeout(function () {
            $(".holy-shit-text").last().addClass("flash-text-grey");
        }, 200);
        setTimeout(function () {
            $(".holy-shit-text").last().removeClass("flash-text-grey");
        }, 2000);
    }

    // Blood
    if (data['bloodySuperstarsData'].length > 0) {
        let bloodySuperstarsNames = Array.from(data['bloodySuperstarsData'], function (s) {
            return s['name']
        });
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            commaSeparate(bloodySuperstarsNames) + ' bled in the match!' +
            '</span>'
        )
    }

    // Feud blowoff results
    data['feuds'].forEach(function (feud) {
        if (feud['ended']) {
            let participantNames = feud['participants'].join(' and ');
            let feudName = feud['name'];
            let rating =
                '<span class="display-inline-block margin-left-8 top--1px">' + getStarRatingHtml(feud['rating']) + '</span>';
            let text =
                '<span class="faded-red-light">' + feudName + '</span>' +
                ' Feud between ' + participantNames + ' ended after the Blowoff' + rating;
            eventUpdatesFeudsSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' +
                text +
                '</span>');
        } else if (feud['stale']) {
            let participantNames = feud['participants'].join(' and ');
            let feudName = feud['name'];
            let overnessChange = '<span class="stale-color">' + feud['overnessDecrease'] +
                '<span class="margin-left-2">%</span></span>';
            let text =
                '<span class="faded-red-light">' + feudName + '</span>' +
                ' Feud between ' + participantNames + ' became <span class="stale-color">Stale</span>' +
                ' with the Fans, lowering the Overness of its Participants by ' + overnessChange + ' each and decreasing its Hype.';
            eventUpdatesFeudsSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' +
                text +
                '</span>');
        } else if (feud['staleWarning']) {
            let participantNames = feud['participants'].join(' and ');
            let feudName = feud['name'];
            let text =
                '<span class="faded-red-light">' + feudName + ' Feud</span>' +
                ' between ' + participantNames +
                ' is starting to become <span class="stale-color">Stale</span> with the Fans.';
            eventUpdatesFeudsSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' +
                text +
                '</span>');
        }
    });

    // Segment Prestige
    data['feudItemsLevelData'].forEach(function (levelData) {
        let levelText;

        let progress;
        let levelXp;
        if (levelData['level'] < 3) {
            levelXp = Math.pow(levelData['level'], 2) * 40;
            progress = (levelData['xp'] / levelXp) * 100;
        } else {
            progress = 100;
            levelXp = Math.pow(2, 2) * 40;
        }

        // Set level
        let level;
        switch (levelData['level']) {
            case 1:
                level = '<i class="fa fa-star-o margin-left-5 font-bold bronze"></i>';
                break;
            case 2:
                level = '<i class="fa fa-star-o margin-left-5 font-bold silver"></i>';
                break;
            case 3:
                level = '<i class="fa fa-star-o margin-left-5 font-bold gold-light"></i>';
                break;
        }

        let xpChangeHtml;
        let xpChange = levelData['xpChange'];
        if (xpChange >= 0) {
            xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + '</span>'
        } else if (xpChange < 0) {
            xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' +
                (-1 * xpChange) + '</span>'
        }

        levelText =
            '<div class="display-block margin-bottom-5">' +
            '<div class="display-inline-block">' +
            '<span>' + levelData['name'] + '</span>' +
            level +
            '</div>' +
            '<div class="display-inline-block float-right">' +
            '<span class="margin-left-5 dark-grey prestige-xp">XP' +
            xpChangeHtml + '</span>' +
            '</div>' +
            '</div>' +
            '<div class="progress-under help-text" title="' + levelData['xp'] + ' / ' + levelXp + ' XP">' +
            '<div class="progress faded-red-light-background" style="width:' + progress + '%">' + '</div>' +
            '</div>';

        // Add level increase data
        if (levelData['levelIncrease']) {
            levelText +=
                '<span class="gold display-block margin-top-12 margin-bottom-2">Level Up!</span>' +
                '<span class="display-block medium-grey">Base Hype' +
                '<i class="fa fa-angle-double-up margin-left-8 margin-right-8"></i>' +
                '<span class="faded-red-light">' +
                '<i class="fa fa-bolt margin-right-5"></i>' +
                levelData['hypeIncrease'] +
                '</span>' +
                '</span>'
        }

        prestigeResultsSelector.find('.event-prestige-header').after('<div class="feud-item-level margin-bottom-25">' +
            levelText + '</div>');

        // Animate XP and progress
        $('.feud-item-level .prestige-xp-value').last().hide().fadeIn('slow');
        setTimeout(function () {
            $('.feud-item-level .progress').last().addClass("expand-width");
        }, 0);
        setTimeout(function () {
            $('.feud-item-level .progress').last().removeClass("expand-width");
        }, 1800);
    });

    // Workrate Increases
    data['workrateIncreases'].forEach(function (superstar) {
        let text =
            '{0}\'s <span class="workrate-blue">Workrate</span> increased to <span class="gold">Level {1}</span>'
                .format(superstar['name'], superstar['level']);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Gimmick Effectiveness Level Changes
    data['gimmickEffectivenessLevelChanges'].forEach(function (gimmickLevelChange) {
        let gimmickLevelChangeHtml = getGimmickEffectivenessLevelChangeHtml(gimmickLevelChange);
        eventUpdatesGimmicksSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            gimmickLevelChangeHtml +
            '</span>'
        );
    });

    // Staff Skill Increases
    data['staffSkillIncreases'].forEach(function (staffMember) {
        let roleHtml = '<span class="light-grey">(' + toTitleCase(staffMember['role'].replace(/_/g, " ")) + ')</span>';
        let skillLevelHtml = '<span class="staff-color">Skill</span>';
        let text =
            '{0}\'s {1} {2} increased to <span class="gold">Level {3}</span>'
                .format(staffMember['name'], roleHtml, skillLevelHtml, staffMember['level']);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Show streaks
    data['streaks'].forEach(function (streak) {
        let streakText;
        if (streak['extended']) {
            let streakHtml =
                '<span class="obsidian">' +
                'Winning Streak' +
                '</span>';
            streakText = '{0}\'s {1} at {2} increased to {3}-0'.format(streak['holder'],
                streakHtml, streak['event'], streak['length']);
        } else if (streak['started']) {
            let streakHtml =
                '<span class="obsidian">' +
                'Winning Streak' +
                '</span>';
            streakText = '{0} started a {1} at {2}'.format(streak['holder'], streakHtml, streak['event'])
        } else if (streak['ended']) {
            let streakHtml =
                '<span class="obsidian">' +
                'Undefeated Streak' +
                '</span>';
            streakText = '{0} ended {1}\'s {2} match {3} at {4}!'.format(streak['winner'],
                streak['holder'], streak['length'], streakHtml, streak['event'])
        }
        eventUpdatesSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' +
            streakText +
            '</span>');
    });

    // Show gimmick match level data
    let levelText;
    let levelData = data['gimmickMatchLevelData'];
    if (levelData) {
        let progress;
        let levelXp;
        if (levelData['level'] < 3) {
            levelXp = Math.pow(levelData['level'], 2) * 50;
            progress = (levelData['xp'] / levelXp) * 100;
        } else {
            progress = 100;
            levelXp = Math.pow(2, 2) * 50;
        }

        // Set level
        let level;
        switch (levelData['level']) {
            case 1:
                level = '<i class="fa fa-star-o margin-left-5 font-bold bronze"></i>';
                break;
            case 2:
                level = '<i class="fa fa-star-o margin-left-5 font-bold silver"></i>';
                break;
            case 3:
                level = '<i class="fa fa-star-o margin-left-5 font-bold gold-light"></i>';
                break;
        }

        let xpChangeHtml;
        let xpChange = levelData['xpChange'];
        if (xpChange >= 0) {
            xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + '</span>'
        } else if (xpChange < 0) {
            xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' +
                (-1 * xpChange) + '</span>'
        }

        levelText =
            '<div class="display-block margin-bottom-5">' +
            '<div class="display-inline-block">' +
            '<span>' + levelData['name'] + ' Match' + '</span>' +
            level +
            '</div>' +
            '<div class="display-inline-block float-right">' +
            '<span class="margin-left-5 dark-grey prestige-xp">XP' +
            xpChangeHtml + '</span>' +
            '</div>' +
            '</div>' +
            '<div class="progress-under help-text" title="' + levelData['xp'] + ' / ' + levelXp + ' XP">' +
            '<div class="progress" style="width:' + progress + '%">' + '</div>' +
            '</div>';

        // Add level increase data
        if (levelData['levelIncrease']) {
            let perk;
            switch (levelData['addedPerk']) {
                case 'rating':
                    perk = 'Rating boost increased for this Gimmick Match!';
                    break;
                case 'injury':
                    perk = 'Injury rate decreased for this Gimmick Match!';
                    break;
                case 'popularity':
                    perk = 'Popularity boost increased for this Gimmick Match!';
                    break;
                case 'cost':
                    perk = 'Cost decreased for this Gimmick Match!';
                    break;
            }
            levelText +=
                '<span class="gold display-block margin-top-12">Level Up!</span>' +
                '<span class="display-block margin-top-5">' + perk + '</span>'
        }

        prestigeResultsSelector.find('.event-prestige-header').after('<div class="gimmick-match-level margin-bottom-25">' +
            levelText + '</div>');
        $('.gimmick-match-level .prestige-xp-value').hide().fadeIn('slow');

        setTimeout(function () {
            $('.gimmick-match-level .progress').addClass("expand-width");
        }, 0);
        setTimeout(function () {
            $('.gimmick-match-level .progress').removeClass("expand-width");
        }, 1800);
    }

    // Show tournament prestige
    let tournamentPrestigeHtml;
    let tournamentPrestige = data['tournamentPrestige'];
    if (tournamentPrestige) {
        let progress = 100;
        if (tournamentPrestige['prestige'] !== 'A') {
            progress = ((tournamentPrestige['xp'] - tournamentPrestige['baseXp']) /
                (tournamentPrestige['xpToNextPrestige'] - tournamentPrestige['baseXp'])) * 100;
        }

        if (progress > 100) {
            progress = 100
        } else if (progress < 0) {
            progress = 0
        }

        let xpChangeHtml;
        let xpChange = tournamentPrestige['xpChange'];
        if (tournamentPrestige['xpChange'] >= 0) {
            xpChangeHtml = '<span class="prestige-xp-value green margin-left-8">+ ' + xpChange + '</span>'
        } else if (tournamentPrestige['xpChange'] < 0) {
            xpChangeHtml = '<span class="prestige-xp-value red margin-left-8">- ' +
                (-1 * xpChange) + '</span>'
        }

        let prestigeIcon;
        switch (tournamentPrestige['prestige']) {
            case 'C':
                prestigeIcon = '<i class="fa fa-star-o margin-left-5 font-bold bronze"></i>';
                break;
            case 'B':
                prestigeIcon = '<i class="fa fa-star-o margin-left-5 font-bold silver"></i>';
                break;
            case 'A':
                prestigeIcon = '<i class="fa fa-star-o margin-left-5 font-bold gold-light"></i>';
                break;
        }

        tournamentPrestigeHtml =
            '<div class="display-block margin-bottom-5">' +
            '<div class="display-inline-block">' +
            '<span>Tourn. Prestige</span>' +
            prestigeIcon +
            '</div>' +
            '<div class="display-inline-block float-right">' +
            '<span class="margin-left-5 dark-grey prestige-xp">XP' +
            xpChangeHtml + '</span>' +
            '</div>' +
            '</div>' +
            '<div class="progress-under help-text" title="' + tournamentPrestige['xp'] + ' / ' +
            tournamentPrestige['xpToNextPrestige'] + ' XP">' +
            '<div class="progress" style="width:' + progress + '%">' + '</div>' +
            '</div>';

        if (tournamentPrestige['prestigeIncrease']) {
            tournamentPrestigeHtml += '<span class="gold display-block margin-top-12">' +
                'Tournament Prestige Increased</span>';
            tournamentPrestigeHtml += '<span class="display-block margin-top-5">' +
                '<i class="fa fa-angle-double-up margin-right-5"></i>' +
                'Final Bonus increased to + ' +
                tournamentPrestige['finalBonus'] + ' for this Tournament</span>';
        } else if (tournamentPrestige['prestigeDecrease']) {
            tournamentPrestigeHtml += '<span class="puke-green display-block margin-top-12">' +
                'Tournament Prestige Decreased</span>';
            tournamentPrestigeHtml += '<span class="display-block margin-top-5">' +
                '<i class="fa fa-angle-double-down margin-right-5"></i>' +
                'Final Bonus decreased to + ' +
                tournamentPrestige['finalBonus'] + ' for this Tournament</span>';
        }

        prestigeResultsSelector.find('.event-prestige-header').after('<div class="tournament-prestige-progress ' +
            ' margin-bottom-25">' + tournamentPrestigeHtml + '</div>');
        $('.tournament-prestige-progress .prestige-xp-value').hide().fadeIn('slow');

        setTimeout(function () {
            $('.tournament-prestige-progress .progress').addClass("expand-width");
        }, 0);
        setTimeout(function () {
            $('.tournament-prestige-progress .progress').removeClass("expand-width");
        }, 1800);
    }

    // Show match effect change
    if (data['matchEffectIncrease']) {
        eventUpdatesSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' +
            '<span class="bronze">' +
            '<i class="fa fa-angle-double-up margin-right-5 dark-grey"></i>' +
            data["matchGimmick"] +
            '</span>' +
            ' Match Effect' +
            ' increased for this Event' +
            '</span>');
    } else if (data['matchEffectDecrease']) {
        eventUpdatesSelector.prepend('<span class="display-block event-match-effect margin-bottom-12">' +
            '<span class="bronze">' +
            '<i class="fa fa-angle-double-down margin-right-5 dark-grey"></i>' +
            data["matchGimmick"] +
            '</span>' +
            ' Match Effect' +
            ' decreased for this Event' +
            '</span>');
    }

    // Tournament advance
    if (data['tournamentAdvance']) {
        let names = data['tournamentAdvance']['names'];
        let group = data['tournamentAdvance']['group'];
        if (names.length > 1) {
            names = names.slice(0, -1).join(', ') + ' and ' + names.slice(-1);
        }
        let text =
            '<span class="cyan">' +
            'knockout stage' +
            '</span>';
        let tournamentAdvanceText = '{0} advanced from Group {1} to the {2}'.format(names,
            getTournamentGroupName(group), text);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12">' + tournamentAdvanceText +
            '</span>'
        )
    }

    // Tournament win
    if (data['tournamentWon']) {
        let won = data['tournamentWon']['tournamentName'];
        let text =
            '<span class="cyan">' +
            won +
            '</span>';
        if (data['tournamentWon']['matchContractName']) {
            text += ' and the ' +
                '<span class="gold">' +
                data["tournamentWon"]["matchContractName"] + ' Contract' +
                '</span>';
        }

        let tournamentWinPrefix = 'won the';
        // Don't add 'the' if tournament name starts with 'the'
        if (data['tournamentWon']['tournamentName'].split(' ')[0].toLowerCase() === 'the') {
            tournamentWinPrefix = 'won'
        }
        let tournamentWinText =
            '{0} {1} {2}!'.format(data['tournamentWon']['name'], tournamentWinPrefix, text);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12">' + tournamentWinText +
            '</span>'
        )
    }

    // Feud consequence results
    if (data['feudConsequenceResults']) {
        let feudResults = data['feudConsequenceResults'];

        feudResults['retirements'].forEach(function (superstar) {
            let text;
            if (superstar['hallOfFame']) {
                text =
                    superstar['name'] +
                    ' has retired and been inducted into the ' +
                    '<span class="gold">' +
                    'Hall of Fame' +
                    '</span>'
            } else {
                text =
                    superstar['name'] +
                    " has retired from wrestling"
            }

            eventUpdatesAvailabilitySelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        });

        // Career not ended
        if (feudResults['careerNotEnded']) {
            let text = '{0}\'s career is not over yet!'.format(
                feudResults['careerNotEnded']);
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        }

        // Main Event Push
        if (feudResults['pushed']) {
            let text = '{0} gained a Popularity Boost to get into the Main Event!'.format(
                feudResults['pushed']);
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        }

        // Unified
        if (feudResults['unifiedChampionships']) {
            let unifiedData = feudResults['unifiedChampionships'];
            let championshipVerb = (unifiedData['multipleChampionships']) ? 'have' : 'has';
            let unifiedChampionshipsName = '<span class="gold">{0}</span>'.format(
                unifiedData['unifiedChampionships']);
            let unifiedChampionshipWithName = '<span class="gold">{0}</span>'.format(
                unifiedData['unifiedChampionshipWith']);

            let text = '{0} {1} been unified with the {2}'.format(
                unifiedChampionshipsName, championshipVerb,
                unifiedChampionshipWithName);

            if (unifiedData['xpChange']) {
                let xpChange = '<span class="green margin-left-5">+ ' +
                    unifiedData['xpChange'] + ' XP</span>';
                text += ', increasing Prestige {0}'.format(xpChange);
            }

            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        }

        // Disbanded
        if (feudResults['disbanded'].length > 0) {
            let text = '{0} have disbanded'.format(commaSeparate(feudResults['disbanded']));
            eventUpdatesAvailabilitySelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        }

        // Forced to leave
        if (feudResults['forcedToLeave']) {
            let verb = feudResults['forcedToLeaveType'] === 'superstar' ? 'has' : 'have';
            let text = '{0} {1} been forced to leave the company for some time!'.format(
                feudResults['forcedToLeave'], verb);
            eventUpdatesAvailabilitySelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        }

        // Left Company
        feudResults['fired'].forEach(function (superstar) {
            let overnessDecrease = '<span class="stale-color">' + superstar['overnessDecrease'] +
                '<span class="margin-left-2">%</span></span>';
            let text = superstar['name'] + ' was fired from the company, ' +
                'lowering ' + superstar['pronoun'] + ' Overness by ' + overnessDecrease;
            eventUpdatesAvailabilitySelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        });

        // Turn Heel
        if (feudResults['turnedHeel']) {
            let text = '{0} fell into corruption and turned Heel!'.format(
                feudResults['turnedHeel']);
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        }
        // Did not turn Heel
        if (feudResults['didNotTurnHeel']) {
            let text = '{0} fought the corruption and remained Face!'.format(
                feudResults['didNotTurnHeel']);
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        }

        // Turn Face
        if (feudResults['turnedFace']) {
            let text = '{0} gained redemption and turned Face!'.format(
                feudResults['turnedFace']);
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        }
        // Did not turn Face
        if (feudResults['didNotTurnFace']) {
            let text = '{0} could not find redemption and remained Heel!'.format(
                feudResults['didNotTurnFace']);
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        }

        // Unmasked
        feudResults['maskRemoved'].forEach(function () {
            let text = '{0} was forced to unmask!'.format(
                feudResults['maskRemoved']);
            eventUpdatesSelector.prepend(
                '<span class="display-block margin-bottom-12 dark-grey">' +
                text +
                '</span>'
            );
        });

        // Faction consequences
        feudResults['factionConsequences'].forEach(function (factionConsequence) {
            let text;
            if (factionConsequence['consequence'] === 'join_faction') {
                text = factionConsequence['name'] + " was forced to join " + factionConsequence['faction'];
            }
            if (factionConsequence['consequence'] === 'leave_faction') {
                text = factionConsequence['name'] + " was forced to leave " + factionConsequence['faction'];
            }
            if (factionConsequence['consequence'] === 'become_faction_leader') {
                text = factionConsequence['name'] + " became the leader of " + factionConsequence['faction'];
            }
            if (factionConsequence['consequence'] === 'did_not_join_faction') {
                text = "Join Faction did not trigger as " + factionConsequence['faction'] + " already have " +
                    gameLimits.maxFactionSuperstars + " members";
            }
            if (text) {
                eventUpdatesSelector.prepend(
                    '<span class="display-block margin-bottom-12 dark-grey">' +
                    text +
                    '</span>'
                );
            }
        });
    }

    // Show faction reputation progress
    data['factionReputationsData'].forEach(function (factionReputationData) {
        showFactionReputationData(factionReputationData);
    });

    data['unavailable'].forEach(function (data) {
        let dataText;
        if (data['type'] === 'injury') {

            let doctorHtml = '';
            if (data['doctorName']) {
                let doctorName = data['doctorName'];
                let doctorAgeMultiplier = data['doctorAgeMultiplier'];
                let doctorXp = '<span class="green margin-left-8">+ ' + data['doctorXpGained'] + ' XP</span>';
                if (doctorAgeMultiplier !== 1) {
                    doctorXp += '<span class="light-grey margin-left-8 font-0p925em">(' +
                        doctorAgeMultiplier + '<span class="help-text" title="Age affects progression of ' +
                        'Skill Level. Younger staff members gain XP faster than older ones.">x Age Multiplier</span>' +
                        ')</span>'
                }
                doctorHtml = doctorName + ' is working to evaluate it' + doctorXp;
            }

            // Injury chance
            let injuryChanceHtml = '';
            if (data['injuryChance']) {
                injuryChanceHtml = '<span class="margin-left-5 light-grey font-0p925em">(' + (Math.round(data['injuryChance'] * 10) / 10) +
                    '<span class="margin-left-2">%</span> chance) </span>'
            }

            let injuryWords = 'an injury';
            if (data['injuryType'] === 'major') {
                injuryWords = 'a severe injury'
            } else if (data['injuryType'] === 'workable') {
                injuryWords = 'a slight injury'
            }
            dataText = '<span class="display-block margin-bottom-12 dark-grey">' +
                data['name'] + ' ' + '<span class="dark-red">' +
                'suffered ' + injuryWords + injuryChanceHtml + '</span>. ' +
                doctorHtml + '</span>';

            // Add vacate championships button
            if (data['championshipsToVacate'].length > 0) {
                let championshipsToVacate = getChampionshipsDisplayName(data['championshipsToVacate'], true);
                let vacateChampionshipsText =
                    '<span class="gold">' + championshipsToVacate + '</span>' + ' suffered an injury ' +
                    '<button type="button" data-superstar-uid="' + data['uid'] + '" class="button retro-button ' +
                    'display-block condensed margin-top-5 blue-button-background vacate-superstar-championships-button">' +
                    'Vacate</button>';
                eventUpdatesAvailabilitySelector.prepend(
                    '<span class="display-block margin-bottom-12 dark-grey">' + vacateChampionshipsText +
                    '</span>'
                )
            }

            // Show injured border
            let elementsFound = $('#match').find('.match-wrestler')
                .filter(function () {
                    return $(this).data("name").indexOf(data['participantName']) >= 0;
                });
            elementsFound.addClass('injured');

        } else if (data['type'] === 'unavailable') {
            if (match['type'] === 'singles') {
                dataText = '<span class="display-block margin-bottom-12 dark-grey">' + data['name'] +
                    ' has been forced to leave the company for some time</span>';
            } else {
                dataText = '<span class="display-block margin-bottom-12 dark-grey">' + data['name'] +
                    ' has been forced to leave the company for some time</span>';
            }
        } else if (data['type'] === 'death') {
            dataText = '<span class="display-block margin-bottom-12 dark-grey">' + data['name'] +
                ' suffered a life-threatening injury and is in critical condition</span>';
        }
        eventUpdatesAvailabilitySelector.prepend(dataText);
    });

    // Hair loss
    data['hairRemoved'].forEach(function (data) {
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            data['name'] + ' got ' + data['possessivePronoun'] + ' hair forcefully shaved off!' +
            '</span>'
        )
    });

    // Hair added
    data['hairAdded'].forEach(function (data) {
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            data['name'] + ' was forced to grow ' + data['possessivePronoun'] + ' hair!' +
            '</span>'
        )
    });

    // Mask removed
    data['maskRemoved'].forEach(function (data) {
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            data['name'] + ' was forced to unmask!' +
            '</span>'
        )
    });

    data['vacated'].forEach(function (vacated) {
        let text;
        let championshipName = getChampionshipDisplayName(vacated);
        if (!vacated['tagTeam'] && !vacated['trio']) {
            text = '<span class="gold">' + championshipName + '</span>' +
                ' has been vacated'
        } else {
            text = '<span class="gold">' + championshipName + '</span>' +
                ' have been vacated'
        }
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Show face of the company notifications
    data['fotcChanges'].forEach(function (data) {
        let faceOfTheCompanyText;
        if (data['faceOfTheCompanyStart']) {
            faceOfTheCompanyText = data['name'] + ' is on the way to becoming a ' +
                '<span class="medium-blue">' +
                'Face of the Company' +
                '</span>';
        } else {
            if (data['faceOfTheCompany']) {
                faceOfTheCompanyText = data['name'] + ' became a ' +
                    '<span class="medium-blue">' +
                    'Face of the Company' +
                    '</span>!';
            } else {
                faceOfTheCompanyText = data['name'] + ' is no longer a Face of the Company';
            }
        }
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + faceOfTheCompanyText +
            '</span>'
        )
    });

    // Feud Potential
    data['feudPotentials'].forEach(function (feud) {
        let feudPotentialHtml = getFeudPotentialHtml(feud);
        eventUpdatesFeudsSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            feudPotentialHtml +
            '</span>'
        );
    });

    // Feud hype increased
    data['feudHypeIncreased'].forEach(function (feud) {
        let feudPotentialHtml = getFeudHypeIncreasedHtml(feud);
        eventUpdatesFeudsSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            feudPotentialHtml +
            '</span>'
        );
    });

    // Feuds started
    data['feudsStarted'].forEach(function (feud) {
        let feudStartedHtml = getFeudStartedHtml(feud);
        eventUpdatesFeudsSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            feudStartedHtml +
            '</span>'
        );
    });

    // Show championship prestige progress
    data['championshipPrestiges'].forEach(function (prestigeData) {
        let prestigeHtml = getChampionshipPrestigeHtml(prestigeData);

        prestigeResultsSelector.find('.event-prestige-header').after('<div class="championship-prestige margin-bottom-20">' +
            prestigeHtml + '</div>');
        $('.championship-prestige .prestige-xp').hide().fadeIn('slow');

        setTimeout(function () {
            $('.championship-prestige .progress').addClass("expand-width");
        }, 0);
        setTimeout(function () {
            $('.championship-prestige .progress').removeClass("expand-width");
        }, 1800);
    });

    // Show unlocked gimmick matches
    if (data['unlockedGimmickMatches'].length > 0) {
        let matchWord = (data['unlockedGimmickMatches'].length === 1) ? 'Match' : 'Matches';
        let unlockText = '<span class="light-blue">' +
            commaSeparate(data['unlockedGimmickMatches']) + ' ' + matchWord +
            '</span>' + ' unlocked!';
        let html = '<span class="display-block margin-bottom-15">' +
            unlockText +
            '</span>';

        prestigeResultsSelector.find('.event-prestige-header').after(html);
    }

    // Show unlocked feud items
    data['unlockedFeudItems'].forEach(function (feudItem) {
        let unlockText = '<span class="faded-red-light">' + feudItem + '</span>' + ' Feud Item unlocked!';
        let html = '<span class="display-block margin-bottom-15">' +
            unlockText +
            '</span>';
        prestigeResultsSelector.find('.event-prestige-header').after(html);
    });

    // Show unlocked championship segment items
    data['unlockedChampionshipSegmentItems'].forEach(function (segmentItem) {
        let unlockText = '<span class="faded-purple">' + segmentItem + '</span>' +
            ' Championship Segment unlocked!';
        let html = '<span class="display-block margin-bottom-15">' +
            unlockText +
            '</span>';
        prestigeResultsSelector.find('.event-prestige-header').after(html);
    });

    // Show unlocked gimmick characters
    data['unlockedCharacters'].forEach(function (unlockedCharacter) {
        let unlockText = '<span class="character-label">' + unlockedCharacter['name'] + '</span>' +
            ' Character unlocked due to the ' + unlockedCharacter['originalCharacter'] +
            ' Character getting Over!';
        let html = '<span class="display-block margin-bottom-15">' +
            unlockText +
            '</span>';
        prestigeResultsSelector.find('.event-prestige-header').after(html);
    });

    // Tournament injury
    if (data['tournamentInjury']) {
        let tournamentInjuryHtml = getTournamentInjuryHtml(data['tournamentInjury']);
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12">' + tournamentInjuryHtml +
            '</span>'
        )
    }

    // Tournament substitution
    if (data['tournamentSubstitution']) {
        let tournamentNameText =
            '<span class="cyan">' +
            data['tournamentSubstitution']['tournamentName'] + ' Tournament' +
            '</span>';

        let substitutionResult = data['tournamentSubstitution'];

        let tournamentInjuryText =
            'Due to {0}\'s injury, {1} took {2} place in the next round of the {3}'.format(
                substitutionResult['injured'], substitutionResult['newMember'],
                substitutionResult['possessivePronoun'], tournamentNameText);

        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12">' + tournamentInjuryText +
            '</span>'
        )
    }

    data['turnedHeel'].forEach(function (participant) {
        let turnText = participant + ' turned <span class="alignment-heel">Heel</span>!';
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            turnText +
            '</span>'
        );
    });

    data['turnedFace'].forEach(function (participant) {
        let turnText = participant + ' turned <span class="alignment-face">Face</span>!';
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            turnText +
            '</span>'
        );
    });

    data['debutedGimmicks'].forEach(function (gimmick) {
        let gimmickDebutHtml = getGimmickDebutHtml(gimmick);
        eventUpdatesGimmicksSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            gimmickDebutHtml +
            '</span>'
        );
    });

    // Show overness change
    if (data['hotMatch']) {
        let overnessChange = '<span class="hot-color">' + data['hotMatchOvernessIncrease'] +
            '<span class="margin-left-2">%</span></span>';

        // Get participant names
        let participantNames = [...data['losers'], data['winner']].map(x => x['name']);
        let participantsText = participantNames.slice(0, -1).join(', ') +
            ' and ' + participantNames.slice(-1);

        let eventHypeBoost = '';
        if (data['eventHypeBoostData']) {
            if (data['eventHypeBoostData']['hotMatchBoost']) {
                eventHypeBoost = ' A lot of viewers tuned in to watch.' +
                    '<span class="medium-dark-grey margin-left-8">+ ' + data['eventHypeBoostData']['hypeBoost'] + ' HYPE</span>';
            }
        }

        let hotMatchText = participantsText + ' put on a <span class="hot-color">Hot</span> Match, ' +
            'boosting their Overness by ' + overnessChange + ' each.' + eventHypeBoost;

        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            hotMatchText +
            '</span>'
        );

        // Update event hype
        $('.event-hype-text').html(getEventHypeHtml(data['eventHype'])).hide().fadeIn('fast');
    }

    // Overness Changes
    data['overnessChanges'].forEach(function (overnessChange) {
        let overnessPercentage = '<span class="light-grey margin-left-5">' + overnessChange['overness'] +
            '<span class="margin-left-2">%</span></span>';
        let changeWord = (overnessChange['increase']) ? 'increased' : 'decreased';
        let text =
            '{0}\'s Overness{1} '.format(overnessChange['name'], overnessPercentage) + changeWord +
            ' to <span class="light-grey">' + overnessChange['currentOverness'] + '</span>' +
            ' from <span class="light-grey">' + overnessChange['previousOverness'] + '</span>';
        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Hot Changes
    data['hotChanges'].forEach(function (hotChange) {
        let text;
        if (hotChange['status'] === 'hotStart') {
            text = hotChange['name'] + ' is starting to get <span class="hot-color">Over</span> with the Fans'
        } else if (hotChange['status'] === 'hotEnd') {
            text = hotChange['name'] + ' is no longer <span class="hot-color">Over</span> with the Fans. ' +
                'All boosts have been removed.'
        } else if (hotChange['status'] === 'hot') {
            text = hotChange['name'] + ' got <span class="hot-color hot-text">Over</span> with the Fans, ' +
                ' boosting ' + hotChange['pronoun'] + ' Attributes and performance in Matches, Segments and Feuds.'
        }
        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        );

        setTimeout(function () {
            $(".hot-text").addClass("flash-text-orange");
        }, 200);
        setTimeout(function () {
            $(".hot-text").removeClass("flash-text-orange");
        }, 3000);
    });

    // Stale Changes
    data['staleChanges'].forEach(function (staleChange) {
        let text;
        if (staleChange['status'] === 'staleStart') {
            text = staleChange['name'] + ' is starting to become <span class="stale-color">Stale</span> with the Fans'
        } else if (staleChange['status'] === 'staleEnd') {
            text = staleChange['name'] + ' is no longer <span class="stale-color">Stale</span> with the Fans. ' +
                'All negative effects have been removed.'
        } else if (staleChange['status'] === 'stale') {
            text = staleChange['name'] + ' became <span class="stale-color stale-text">Stale</span> with the Fans, ' +
                ' lowering ' + staleChange['pronoun'] + ' performance in Matches, Segments and Feuds.'
        }
        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        );

        setTimeout(function () {
            $(".stale-text").addClass("flash-text-stale");
        }, 200);
        setTimeout(function () {
            $(".stale-text").removeClass("flash-text-stale");
        }, 3000);
    });

    // Show hot feuds
    data['hotFeuds'].forEach(function (feud) {
        let overnessChange = '<span class="hot-color">' + feud['overnessIncrease'] +
            '<span class="margin-left-2">%</span></span>';

        // Get participant names
        let participantNames = [...feud['participants']];
        let participantsText = participantNames.slice(0, -1).join(', ') +
            ' and ' + participantNames.slice(-1);

        let feudName = feud['name'];
        let hotFeudText =
            '<span class="faded-red-light">{0}</span> Feud between {1} became <span class="hot-color">Hot</span>,'
                .format(feudName, participantsText) +
            ' boosting its chance to have Hot Matches and Segments and the Overness of the Participants by ' +
            overnessChange + ' each.';

        eventUpdatesOvernessSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' +
            hotFeudText +
            '</span>'
        );
    });

    // Morale Changes
    data['moraleChanges'].forEach(function (moraleChange) {
        let moralePercentage = '<span class="light-grey margin-left-5">' + moraleChange['morale'] +
            '<span class="margin-left-2">%</span></span>';
        let text =
            '{0}\'s Morale{1} '.format(moraleChange['name'], moralePercentage) +
            ' changed to <span class="light-grey">' + moraleChange['currentMorale'] +
            '</span> from <span class="light-grey">' + moraleChange['previousMorale'] + '</span>';
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });

    // Managers added/removed
    data['managersAdded'].forEach(function (managerAdded) {
        let text = '<span class="display-block">Assigned {0} to manage {1}</span>'.format(managerAdded['managerName'], commaSeparate(managerAdded['managedSuperstarsNames']));
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });
    data['managersRemoved'].forEach(function (managerRemoved) {
        let text = '<span class="display-block">Removed {0} from managing {1}</span>'.format(managerRemoved['managerName'], commaSeparate(managerRemoved['removedSuperstarsNames']));
        eventUpdatesSelector.prepend(
            '<span class="display-block margin-bottom-12 dark-grey">' + text +
            '</span>'
        )
    });
}

function showGetChampionshipContractHoldersData({data, element} = {}) {
    let options = [];
    data.forEach(function (holder) {
        options.push(
            '<option value="' + holder['uid'] + '">' + holder['name'] + '</option>'
        );
    });

    // Create new div with championship names and time of cashin
    let div = '<div class="championship-contract-cashin-box display-block margin-top-20 text-center">' +
        '<select name="cashin-championships">' +
        options +
        '</select>' +
        '<select name="cashin-time">' +
        '<option value="0" selected>Now</option>' +
        '<option value="1">After Match</option>' +
        '</select>' +
        '<button type="button" id="championship-contract-cashin" ' +
        'class="button retro-button condensed gold-button-background margin-left-2" data-match-uid="' +
        element.attr('data-match-uid') + '">' +
        'Cash In' +
        '</button>' +
        '</div>';

    // Add new div and remove previous one
    element.replaceWith(div);
}

function showGetChampionshipsForCashinData({data, element} = {}) {
    // Add championship names
    let options = [];
    data.forEach(function (championship) {
        options.push(
            "<option value='" + championship['uid'] + "'>" + championship['name'] + "</option>"
        );
    });

    // Create new div with championship names and time of cashin
    let div = '<div class="championship-contract-cashin-box display-block">' +
        '<div class="line-height-1p4 font-0p925em grey-blue-dark margin-top-5">' +
        '<i class="fa fa-info-circle margin-right-2"></i> Cash in for a championship match at the upcoming event.' +
        '</div>' +
        '<select name="cashin-championships">' +
        options +
        '</select>' +
        '<button type="button" id="championship-contract-cashin" ' +
        'class="button retro-button condensed gold-button-background margin-top-5" data-uid="' + element.attr('data-uid') + '">' +
        'Cash In' +
        '</button>' +
        '</div>';

    // Add new div and remove previous one
    element.parent().after(div);
    element.prev().text(' ');
    element.remove();
}

async function showAddCashinFutureMatchData({data} = {}) {
    if (data['error']) {
        if (data['error'] === 'no-women-allowed') {
            notie.alert({type: 3, text: "Women are not allowed to be booked at this event"});
        }
        if (data['error'] === 'no-men-allowed') {
            notie.alert({type: 3, text: "Men are not allowed to be booked at this event"});
        }
        if (data['error'] === 'production-packages-only') {
            notie.alert({type: 3, text: "You can only book Production Segments at this Event"});
        }
        if (data['error'] === 'championship-not-found') {
            notie.alert({type: 3, text: "That championship could not be found"});
        }
        if (data['error'] === 'challenger-is-champion') {
            notie.alert({type: 3, text: "Champions can't cash in on themselves!"});
        }
        return false;
    }
    await loadHomePage(await getCurrentGame());
}

export {showPlayMatchPage, getTournamentInjuryHtml}